var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 78 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.515.379H0v12.28h3.498c1.86 0 3.202-.435 4.383-1.42a6.17 6.17 0 0 0 2.231-4.716C10.108 2.902 7.4.38 3.515.38m2.798 9.227c-.753.68-1.732.975-3.28.975h-.642v-8.12h.642c1.548 0 2.486.276 3.28.992.828.737 1.326 1.88 1.326 3.058S7.14 8.869 6.313 9.606M13.606.379h-2.395v12.28h2.395zM19.467 5.091c-1.436-.53-1.86-.885-1.86-1.547 0-.774.753-1.363 1.786-1.363.72 0 1.309.297 1.93.996l1.255-1.642A5.37 5.37 0 0 0 18.97.173c-2.173 0-3.832 1.51-3.832 3.519 0 1.691.774 2.56 3.021 3.366.939.33 1.416.552 1.655.7.477.313.72.753.72 1.272 0 .996-.79 1.733-1.86 1.733-1.14 0-2.062-.573-2.614-1.639l-1.547 1.49c1.103 1.622 2.428 2.338 4.251 2.338 2.49 0 4.235-1.655 4.235-4.033 0-1.951-.806-2.836-3.531-3.832zM23.755 6.528c0 3.609 2.836 6.408 6.483 6.408 1.033 0 1.913-.202 3.004-.716V9.4c-.959.96-1.807 1.346-2.893 1.346-2.412 0-4.124-1.749-4.124-4.235 0-2.358 1.765-4.218 4.012-4.218 1.145 0 2.009.407 3.005 1.382V.856c-1.05-.535-1.918-.753-2.947-.753-3.63 0-6.54 2.856-6.54 6.429zM52.236 8.626 48.96.38h-2.613l5.21 12.598h1.288L58.155.379h-2.602zM59.237 12.66h6.795V10.58h-4.404V7.264h4.24V5.186h-4.24V2.46h4.404V.38h-6.795zM75.518 4.005c0-2.301-1.585-3.626-4.346-3.626H67.62v12.28h2.391V7.726h.313l3.317 4.935h2.947L72.72 7.486c1.807-.366 2.8-1.6 2.8-3.481m-4.807 2.029h-.7V2.313h.737c1.494 0 2.305.626 2.305 1.82s-.811 1.9-2.342 1.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.428 1.02c0-.213-.148-.332-.412-.332h-.346V1.77h.26v-.42l.304.42h.317l-.358-.449c.152-.04.239-.152.239-.3zm-.457.149h-.045V.885h.045q.192-.001.193.14 0 .143-.197.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.066.284a.937.937 0 0 0-.943.943c0 .522.424.946.942.946A.94.94 0 0 0 78 1.227a.94.94 0 0 0-.934-.943m0 1.72a.763.763 0 0 1-.754-.773.76.76 0 0 1 .754-.774c.42 0 .749.354.749.774s-.334.774-.75.774"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__a)",
    d: "M47.026 6.507a6.503 6.503 0 0 1-13.005 0 6.503 6.503 0 1 1 13.005-.004z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover_svg__b)",
    d: "M47.026 6.507a6.503 6.503 0 0 1-13.005 0 6.503 6.503 0 1 1 13.005-.004z",
    opacity: 0.65,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "discover_svg__c",
    width: 14,
    height: 14,
    x: 34,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.026 6.506a6.503 6.503 0 1 1-13.007 0 6.503 6.503 0 0 1 13.007 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#discover_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#010000",
    d: "M40.548-.103a6.63 6.63 0 0 1 6.634 6.63 6.64 6.64 0 0 1-7.075 6.626 6.63 6.63 0 0 1-6.194-6.618q-.001-.133.004-.267a6.635 6.635 0 0 1 6.63-6.371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020100",
    d: "M40.551-.095c3.663 0 6.639 2.963 6.639 6.626a6.64 6.64 0 0 1-7.075 6.627 6.633 6.633 0 0 1-6.198-6.619c0-.09 0-.176.004-.267a6.637 6.637 0 0 1 6.63-6.367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#030101",
    d: "M40.556-.09c3.663 0 6.638 2.958 6.638 6.625a6.643 6.643 0 0 1-7.074 6.63 6.63 6.63 0 0 1-6.199-6.613q-.001-.133.005-.268a6.64 6.64 0 0 1 6.63-6.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040101",
    d: "M40.56-.083c3.663 0 6.642 2.96 6.642 6.622a6.645 6.645 0 0 1-7.07 6.63 6.63 6.63 0 0 1-6.198-6.613q-.001-.133.004-.268a6.62 6.62 0 0 1 6.622-6.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050201",
    d: "M40.564-.079c3.663 0 6.643 2.955 6.643 6.618a6.65 6.65 0 0 1-7.071 6.635c-3.461-.222-6.202-3.095-6.202-6.61q-.001-.134.004-.267A6.635 6.635 0 0 1 40.564-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#060201",
    d: "M40.568-.07c3.663 0 6.643 2.95 6.643 6.614a6.654 6.654 0 0 1-7.07 6.634c-3.462-.222-6.203-3.095-6.203-6.61q-.001-.133.004-.267c.14-3.544 3.054-6.375 6.626-6.371"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#070301",
    d: "M40.572-.066c3.663.004 6.647 2.947 6.647 6.61s-2.976 6.642-6.63 6.65c-.148 0-.297 0-.44-.012a6.63 6.63 0 0 1-6.207-6.605c0-.091 0-.177.004-.268.14-3.548 3.054-6.38 6.626-6.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080302",
    d: "M40.576-.058c3.663.004 6.647 2.943 6.647 6.606s-2.976 6.642-6.63 6.655c-.149 0-.297 0-.44-.013-3.462-.218-6.207-3.09-6.207-6.605q-.001-.133.004-.268c.14-3.548 3.054-6.383 6.626-6.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090302",
    d: "M40.58-.054c3.66.004 6.647 2.943 6.647 6.602 0 3.658-2.975 6.642-6.626 6.655-.148 0-.296 0-.44-.013-3.462-.218-6.207-3.09-6.207-6.605 0-.091 0-.177.004-.268.14-3.548 3.054-6.38 6.626-6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A0402",
    d: "M40.58-.046c3.66.009 6.651 2.939 6.651 6.598s-2.975 6.643-6.626 6.659c-.148 0-.296 0-.44-.012a6.625 6.625 0 0 1-6.21-6.602q0-.133.003-.267c.14-3.548 3.054-6.38 6.622-6.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B0402",
    d: "M40.585-.042c3.658.009 6.65 2.935 6.65 6.594s-2.975 6.647-6.626 6.659c-.148 0-.296 0-.44-.012-3.461-.214-6.21-3.087-6.21-6.602q-.001-.133.004-.267c.14-3.548 3.053-6.384 6.622-6.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C0402",
    d: "M40.589-.037c3.658.008 6.65 2.93 6.65 6.589s-2.975 6.647-6.626 6.663c-.148 0-.296 0-.44-.012-3.461-.214-6.21-3.083-6.21-6.598q-.001-.134.004-.267c.14-3.548 3.053-6.384 6.622-6.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0D0503",
    d: "M40.593-.03c3.659.009 6.655 2.927 6.655 6.59s-2.976 6.647-6.626 6.663c-.148 0-.297 0-.44-.012-3.462-.214-6.211-3.083-6.215-6.598q-.001-.133.004-.267c.14-3.548 3.054-6.384 6.622-6.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0503",
    d: "M40.597-.025c3.659.008 6.655 2.926 6.655 6.585s-2.98 6.647-6.626 6.667c-.148 0-.297 0-.44-.012-3.462-.21-6.215-3.083-6.215-6.593q-.001-.133.004-.268c.14-3.548 3.054-6.383 6.622-6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0603",
    d: "M40.601-.017c3.659.008 6.66 2.922 6.66 6.581s-2.98 6.647-6.623 6.672c-.148 0-.296 0-.44-.013-3.462-.21-6.215-3.078-6.219-6.593q-.001-.133.004-.268c.14-3.551 3.058-6.387 6.622-6.379z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#100603",
    d: "M40.605-.013c3.659.009 6.66 2.918 6.66 6.577s-2.98 6.651-6.623 6.672c-.148 0-.296 0-.44-.013-3.462-.21-6.215-3.078-6.22-6.589q-.001-.133.005-.267c.14-3.552 3.058-6.388 6.622-6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#110603",
    d: "M40.61-.004c3.658.012 6.659 2.914 6.659 6.572 0 3.66-2.98 6.651-6.623 6.676-.148 0-.296 0-.44-.012-3.461-.21-6.219-3.075-6.219-6.59q-.001-.134.004-.267c.14-3.552 3.058-6.388 6.618-6.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#120703",
    d: "M40.613 0c3.66.012 6.664 2.91 6.664 6.568 0 3.659-2.98 6.651-6.623 6.676-.148 0-.296 0-.44-.013-3.465-.205-6.219-3.074-6.223-6.589q-.001-.133.004-.267c.14-3.552 3.058-6.392 6.618-6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#130704",
    d: "M40.618.008c3.658.012 6.663 2.906 6.663 6.564 0 3.66-2.98 6.651-6.622 6.68-.148 0-.297 0-.44-.012-3.466-.206-6.22-3.075-6.223-6.585q-.001-.133.004-.268c.136-3.552 3.058-6.391 6.618-6.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#140704",
    d: "M40.622.012c3.654.012 6.663 2.906 6.663 6.56 0 3.655-2.98 6.655-6.618 6.68-.148 0-.296 0-.444-.012-3.466-.206-6.223-3.07-6.227-6.585q-.001-.133.004-.268c.136-3.552 3.058-6.391 6.618-6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#150804",
    d: "M40.626.02c3.654.013 6.667 2.902 6.667 6.557 0 3.654-2.98 6.655-6.618 6.683-.148 0-.296 0-.445-.012-3.465-.202-6.222-3.07-6.227-6.58q-.001-.135.005-.268c.135-3.556 3.057-6.396 6.618-6.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#160804",
    d: "M40.63.024c3.655.013 6.667 2.898 6.667 6.553s-2.98 6.655-6.618 6.683c-.148 0-.296 0-.444-.012-3.466-.202-6.223-3.066-6.227-6.58q-.001-.135.004-.268C34.148 2.844 37.07.004 40.63.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#170904",
    d: "M40.634.028c3.655.013 6.667 2.894 6.667 6.553s-2.983 6.655-6.618 6.687c-.148 0-.296 0-.444-.012-3.465-.201-6.227-3.066-6.231-6.577q-.001-.133.004-.267C34.148 2.856 37.07.016 40.626.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#180905",
    d: "M40.638.037c3.655.016 6.672 2.889 6.672 6.548s-2.984 6.655-6.618 6.692c-.148 0-.297 0-.445-.012-3.465-.202-6.227-3.067-6.23-6.577q0-.133.003-.268c.136-3.556 3.058-6.4 6.614-6.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#190905",
    d: "M40.642.04c3.655.017 6.672 2.89 6.672 6.545s-2.984 6.659-6.618 6.692c-.148 0-.297 0-.445-.012-3.465-.198-6.227-3.063-6.231-6.573q-.001-.133.004-.268c.136-3.556 3.058-6.4 6.614-6.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A0A05",
    d: "M40.646.05c3.655.016 6.676 2.884 6.676 6.539s-2.984 6.659-6.614 6.696q-.222.002-.444-.008c-3.466-.198-6.232-3.062-6.236-6.573q-.001-.133.004-.267c.136-3.556 3.058-6.4 6.614-6.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B0A05",
    d: "M40.646.053c3.655.016 6.676 2.881 6.676 6.536s-2.984 6.659-6.614 6.696q-.222.002-.444-.008c-3.466-.198-6.232-3.062-6.236-6.569q-.001-.133.004-.267c.136-3.56 3.058-6.4 6.614-6.388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C0A05",
    d: "M40.65.061c3.655.017 6.676 2.877 6.676 6.532s-2.984 6.66-6.614 6.7q-.222.002-.444-.008c-3.466-.197-6.231-3.058-6.24-6.569q-.001-.134.004-.267C34.168 2.889 37.09.045 40.646.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D0B06",
    d: "M40.655.065c3.654.017 6.68 2.873 6.68 6.528s-2.985 6.663-6.614 6.7q-.223.002-.445-.008c-3.465-.193-6.235-3.058-6.24-6.569q-.001-.134.005-.267c.136-3.56 3.058-6.404 6.614-6.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E0B06",
    d: "M40.659.074c3.654.02 6.68 2.873 6.68 6.523s-2.985 6.663-6.615 6.705c-.148 0-.296 0-.444-.009-3.465-.193-6.235-3.053-6.24-6.564q-.001-.133.005-.268c.136-3.56 3.058-6.404 6.61-6.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F0C06",
    d: "M40.663.078c3.65.02 6.68 2.868 6.68 6.519 0 3.65-2.984 6.663-6.61 6.704-.148 0-.296 0-.445-.008-3.465-.193-6.235-3.054-6.243-6.564q-.001-.133.004-.268c.136-3.56 3.058-6.408 6.61-6.387z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#200C06",
    d: "M40.667.086c3.65.02 6.684 2.864 6.684 6.52 0 3.654-2.988 6.662-6.61 6.708q-.222.002-.444-.008c-3.466-.19-6.24-3.054-6.244-6.56q-.001-.135.004-.268c.136-3.56 3.058-6.409 6.61-6.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#210C06",
    d: "M40.671.09c3.65.02 6.684 2.86 6.684 6.515s-2.988 6.668-6.61 6.713c-.148 0-.296 0-.444-.008-3.466-.19-6.24-3.05-6.244-6.56q-.001-.135.004-.268C34.197 2.918 37.12.074 40.671.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#220D07",
    d: "M40.675.098c3.65.021 6.684 2.857 6.684 6.511s-2.988 6.668-6.61 6.713c-.148 0-.296 0-.444-.008-3.466-.19-6.24-3.05-6.248-6.556q-.001-.133.004-.268c.136-3.564 3.058-6.412 6.61-6.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#230D07",
    d: "M40.68.102c3.65.021 6.687 2.857 6.687 6.507s-2.988 6.668-6.61 6.717q-.222.002-.444-.008c-3.47-.19-6.244-3.046-6.248-6.556 0-.091 0-.177.005-.268.135-3.564 3.057-6.412 6.61-6.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#240D07",
    d: "M40.683.107c3.651.02 6.688 2.852 6.688 6.502s-2.988 6.668-6.61 6.717q-.222.002-.444-.008c-3.47-.185-6.243-3.046-6.252-6.552q-.001-.133.005-.268c.135-3.564 3.057-6.412 6.605-6.391z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#250E07",
    d: "M40.687.115c3.651.025 6.693 2.848 6.693 6.499s-2.989 6.667-6.606 6.72c-.148 0-.297 0-.445-.008-3.47-.185-6.243-3.045-6.251-6.552q-.001-.133.004-.267C34.218 2.942 37.14.09 40.687.115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#260E07",
    d: "M40.692.119c3.65.025 6.692 2.844 6.692 6.495 0 3.65-2.988 6.671-6.606 6.72-.148 0-.296 0-.444-.008-3.47-.185-6.248-3.041-6.252-6.552q-.001-.133.004-.267C34.222 2.942 37.144.09 40.692.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#270F08",
    d: "M40.696.127c3.65.025 6.692 2.84 6.692 6.49s-2.988 6.672-6.606 6.726q-.222.002-.444-.008c-3.47-.182-6.248-3.042-6.256-6.549q-.001-.133.004-.267C34.222 2.95 37.144.103 40.692.123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280F08",
    d: "M40.7.131c3.65.025 6.696 2.836 6.696 6.487 0 3.65-2.992 6.671-6.606 6.729-.148 0-.296 0-.444-.009-3.47-.18-6.248-3.037-6.256-6.548q-.001-.133.004-.267C34.23 2.955 37.152.103 40.7.127z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#290F08",
    d: "M40.704.14c3.65.024 6.696 2.835 6.696 6.482 0 3.646-2.992 6.671-6.605 6.729q-.223.002-.445-.008c-3.47-.181-6.252-3.038-6.256-6.544q-.001-.133.004-.268c.136-3.568 3.058-6.42 6.606-6.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A1008",
    d: "M40.708.144c3.65.024 6.696 2.831 6.696 6.482 0 3.65-2.992 6.675-6.601 6.733-.149 0-.297 0-.445-.008-3.47-.181-6.252-3.038-6.26-6.544q-.001-.134.004-.264c.136-3.568 3.058-6.42 6.606-6.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B1008",
    d: "M40.712.152c3.647.025 6.7 2.827 6.7 6.478s-2.992 6.676-6.601 6.733q-.223.002-.445-.008c-3.47-.177-6.251-3.033-6.26-6.54q-.001-.134.005-.263c.135-3.569 3.058-6.42 6.601-6.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C1009",
    d: "M40.712.156c3.647.029 6.7 2.823 6.7 6.474 0 3.65-2.992 6.676-6.6 6.737q-.224.002-.445-.008c-3.47-.177-6.256-3.033-6.264-6.54q-.001-.134.004-.263C34.243 2.988 37.165.13 40.708.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D1109",
    d: "M40.716.164c3.647.029 6.7 2.82 6.7 6.47s-2.992 6.676-6.601 6.737c-.148 0-.296 0-.444-.008-3.47-.177-6.256-3.029-6.265-6.535q-.001-.135.005-.264c.135-3.572 3.058-6.424 6.601-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E1109",
    d: "M40.72.168c3.647.03 6.705 2.82 6.705 6.466s-2.992 6.676-6.602 6.742c-.148 0-.296 0-.444-.009-3.47-.177-6.256-3.029-6.264-6.535q-.001-.134.004-.264c.136-3.572 3.058-6.424 6.601-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F1209",
    d: "M40.725.173c3.646.028 6.704 2.815 6.704 6.461s-2.992 6.68-6.602 6.742c-.148 0-.296 0-.444-.009-3.47-.172-6.26-3.029-6.268-6.531q-.001-.134.004-.264C34.255 3 37.177.144 40.72.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#301209",
    d: "M40.729.18c3.646.03 6.708 2.812 6.708 6.458s-2.992 6.68-6.597 6.746q-.223.002-.445-.008c-3.47-.173-6.26-3.025-6.268-6.532q-.001-.135.004-.263c.136-3.573 3.058-6.43 6.602-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31120A",
    d: "M40.733.185c3.646.029 6.708 2.807 6.708 6.453s-2.996 6.68-6.597 6.75c-.148 0-.297 0-.445-.008-3.47-.173-6.26-3.025-6.272-6.532q-.001-.134.004-.263c.132-3.573 3.058-6.429 6.602-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32130A",
    d: "M40.737.193c3.646.033 6.709 2.803 6.709 6.45 0 3.646-2.997 6.68-6.598 6.75-.148 0-.296 0-.444-.01-3.47-.168-6.264-3.02-6.273-6.527q-.001-.134.005-.263c.131-3.572 3.057-6.433 6.597-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33130A",
    d: "M40.741.197C44.388.23 47.454 3 47.454 6.642s-2.996 6.684-6.598 6.754q-.222.001-.444-.004c-3.47-.169-6.264-3.02-6.272-6.527q-.001-.134.004-.264C34.276 3.025 37.202.168 40.74.197"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34130A",
    d: "M40.745.205c3.647.033 6.713 2.799 6.713 6.445s-2.996 6.684-6.597 6.754q-.223.001-.445-.004c-3.47-.169-6.264-3.02-6.276-6.523q-.001-.132.004-.264C34.276 3.037 37.202.181 40.74.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35140A",
    d: "M40.749.21c3.646.032 6.713 2.794 6.713 6.44s-2.997 6.684-6.594 6.758q-.222.001-.444-.004c-3.474-.168-6.268-3.017-6.276-6.523 0-.086 0-.177.004-.263C34.283 3.04 37.209.18 40.749.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36140A",
    d: "M40.753.218c3.642.033 6.717 2.79 6.717 6.437 0 3.646-2.996 6.684-6.593 6.758q-.223.001-.445-.005c-3.474-.164-6.268-3.016-6.276-6.519 0-.086 0-.177.004-.263.132-3.577 3.058-6.437 6.597-6.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37150B",
    d: "M40.757.222c3.643.033 6.717 2.786 6.717 6.433s-2.996 6.684-6.593 6.762q-.222.001-.445-.004c-3.473-.165-6.268-3.013-6.28-6.52 0-.086 0-.177.004-.263.132-3.576 3.058-6.437 6.597-6.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38150B",
    d: "M40.762.23c3.642.033 6.716 2.782 6.716 6.429 0 3.646-2.996 6.688-6.593 6.762q-.222.001-.444-.004c-3.474-.165-6.273-3.013-6.28-6.516q0-.13.003-.263c.132-3.576 3.058-6.437 6.594-6.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39150B",
    d: "M40.766.234c3.642.037 6.72 2.782 6.72 6.425s-3 6.688-6.593 6.766q-.222.001-.444-.004c-3.474-.165-6.273-3.013-6.285-6.515q-.001-.132.004-.264c.132-3.58 3.058-6.44 6.593-6.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A160B",
    d: "M40.77.238c3.642.037 6.72 2.778 6.72 6.42s-3 6.689-6.592 6.771q-.223.001-.445-.004c-3.474-.16-6.272-3.009-6.285-6.515q-.001-.132.005-.264c.131-3.58 3.057-6.44 6.593-6.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B160B",
    d: "M40.774.247c3.642.037 6.725 2.774 6.725 6.416s-3 6.688-6.59 6.77q-.221.001-.444-.004c-3.473-.16-6.276-3.008-6.284-6.51 0-.087 0-.178.004-.264.131-3.58 3.058-6.441 6.593-6.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C160C",
    d: "M40.778.25c3.642.038 6.725 2.77 6.725 6.413 0 3.642-3 6.692-6.59 6.774q-.22.001-.444-.004c-3.473-.16-6.276-3.004-6.288-6.51 0-.087 0-.178.004-.264.131-3.58 3.058-6.445 6.593-6.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D170C",
    d: "M40.778.259c3.642.037 6.725 2.766 6.725 6.408s-3 6.692-6.59 6.774q-.22.001-.444-.004c-3.473-.156-6.276-3.004-6.288-6.507 0-.086 0-.177.004-.263.131-3.58 3.062-6.445 6.593-6.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E170C",
    d: "M40.782.263c3.643.037 6.73 2.766 6.73 6.408s-3.001 6.692-6.59 6.779q-.222.001-.444-.005c-3.474-.156-6.28-3.004-6.289-6.506q-.001-.132.004-.264c.132-3.58 3.062-6.445 6.593-6.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F180C",
    d: "M40.786.271c3.643.037 6.73 2.762 6.73 6.404s-3 6.692-6.59 6.779q-.222.001-.444-.004c-3.474-.157-6.28-3-6.293-6.503 0-.086 0-.177.004-.263.132-3.585 3.062-6.45 6.59-6.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40180C",
    d: "M40.79.275c3.643.042 6.73 2.758 6.73 6.4s-3 6.692-6.585 6.783h-.445c-3.474-.156-6.28-3-6.293-6.503 0-.086 0-.177.004-.263.132-3.585 3.062-6.45 6.59-6.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41180D",
    d: "M40.795.284c3.638.04 6.733 2.753 6.733 6.395 0 3.643-3 6.697-6.585 6.787h-.445c-3.473-.152-6.284-2.996-6.297-6.498q-.001-.132.004-.264c.132-3.585 3.062-6.45 6.59-6.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42190D",
    d: "M40.798.288c3.639.04 6.734 2.749 6.734 6.391s-3.005 6.696-6.585 6.787h-.445c-3.474-.152-6.285-2.996-6.297-6.499 0-.086 0-.177.004-.263C34.341 3.119 37.271.25 40.8.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43190D",
    d: "M40.803.296c3.638.041 6.733 2.75 6.733 6.387 0 3.639-3.004 6.697-6.585 6.791h-.445c-3.473-.152-6.284-2.996-6.297-6.498q-.001-.132.005-.264C34.345 3.127 37.276.26 40.803.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#44190D",
    d: "M40.807.3c3.638.041 6.737 2.745 6.737 6.383s-3.004 6.697-6.585 6.791h-.445c-3.473-.152-6.288-2.992-6.3-6.494q-.001-.132.004-.264c.131-3.584 3.061-6.453 6.589-6.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451A0D",
    d: "M40.811.304c3.638.041 6.737 2.741 6.737 6.38s-3.004 6.7-6.585 6.794c-.148.005-.296 0-.444 0-3.474-.148-6.289-2.992-6.301-6.494q-.001-.132.004-.264c.132-3.588 3.062-6.453 6.59-6.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#461A0E",
    d: "M40.815.312c3.638.046 6.742 2.737 6.742 6.376 0 3.638-3.005 6.7-6.582 6.795-.148.004-.296 0-.444 0-3.478-.149-6.289-2.988-6.301-6.49 0-.087 0-.178.004-.264.132-3.59 3.062-6.458 6.585-6.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#471A0E",
    d: "M40.82.316c3.637.046 6.74 2.733 6.74 6.376 0 3.642-3.004 6.7-6.58 6.799-.148.004-.297 0-.445 0-3.478-.149-6.293-2.988-6.305-6.49 0-.087 0-.178.004-.264C34.366 3.148 37.296.279 40.82.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#481B0E",
    d: "M40.823.325c3.638.045 6.742 2.733 6.742 6.37 0 3.639-3.005 6.701-6.581 6.8-.149.004-.297 0-.445 0-3.478-.144-6.293-2.988-6.305-6.486q-.001-.132.004-.264C34.37 3.156 37.3.288 40.823.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#491B0E",
    d: "M40.828.329c3.638.045 6.745 2.729 6.745 6.367s-3.004 6.7-6.58 6.803c-.15.004-.297 0-.445 0-3.478-.144-6.293-2.984-6.31-6.486q-.001-.132.004-.264C34.374 3.16 37.304.288 40.828.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A1C0E",
    d: "M40.831.337c3.639.045 6.746 2.725 6.746 6.363s-3.009 6.704-6.581 6.807c-.148.004-.296 0-.445 0-3.477-.144-6.297-2.984-6.309-6.482 0-.086 0-.177.004-.263.132-3.59 3.062-6.462 6.585-6.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B1C0F",
    d: "M40.836.341c3.638.046 6.745 2.72 6.745 6.359s-3.008 6.704-6.577 6.807c-.148.004-.296 0-.444 0-3.478-.144-6.297-2.984-6.31-6.482 0-.086 0-.177.005-.263.131-3.59 3.062-6.462 6.585-6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C1C0F",
    d: "M40.84.35c3.634.045 6.75 2.716 6.75 6.354s-3.009 6.704-6.577 6.811c-.148.005-.296 0-.445 0-3.477-.14-6.297-2.98-6.313-6.478 0-.086 0-.177.004-.263.132-3.593 3.062-6.466 6.58-6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D1D0F",
    d: "M40.844.354c3.634.049 6.75 2.712 6.75 6.35s-3.009 6.705-6.577 6.812c-.149.004-.297 0-.445 0-3.478-.14-6.3-2.98-6.313-6.479 0-.086 0-.177.004-.263.132-3.593 3.062-6.466 6.58-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E1D0F",
    d: "M40.844.362c3.634.05 6.75 2.712 6.75 6.346s-3.009 6.709-6.577 6.816a8 8 0 0 1-.445 0c-3.477-.14-6.3-2.976-6.317-6.478q-.001-.132.004-.264c.128-3.593 3.062-6.465 6.58-6.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F1D0F",
    d: "M40.848.366c3.634.05 6.754 2.708 6.754 6.342s-3.009 6.709-6.577 6.816a8 8 0 0 1-.445 0c-3.477-.136-6.3-2.976-6.317-6.474q-.001-.132.004-.264c.127-3.593 3.062-6.47 6.58-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#501E10",
    d: "M40.852.37c3.634.05 6.754 2.704 6.754 6.338s-3.009 6.709-6.577 6.82a8 8 0 0 1-.444 0c-3.478-.136-6.306-2.976-6.318-6.474q-.001-.132.004-.264C34.4 3.197 37.333.32 40.852.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#511E10",
    d: "M40.856.378c3.634.05 6.754 2.7 6.754 6.338s-3.009 6.709-6.573 6.82a8 8 0 0 1-.444 0c-3.478-.136-6.306-2.971-6.322-6.47 0-.086 0-.177.004-.263.128-3.593 3.062-6.47 6.581-6.425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#521F10",
    d: "M40.86.382c3.634.05 6.758 2.696 6.758 6.334 0 3.639-3.008 6.713-6.573 6.824a8 8 0 0 1-.444 0c-3.478-.135-6.305-2.971-6.322-6.47 0-.086 0-.177.004-.263.128-3.597 3.063-6.474 6.581-6.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#531F10",
    d: "M40.865.39c3.634.05 6.758 2.696 6.758 6.33s-3.013 6.713-6.573 6.828a8 8 0 0 1-.445 0c-3.477-.131-6.309-2.967-6.321-6.465q-.001-.132.004-.264C34.415 3.222 37.35.345 40.865.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#541F10",
    d: "M40.869.395c3.634.053 6.762 2.691 6.762 6.325s-3.013 6.713-6.573 6.828a8 8 0 0 1-.445 0c-3.477-.131-6.309-2.967-6.325-6.465q-.001-.132.004-.264c.127-3.597 3.062-6.474 6.576-6.424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#552010",
    d: "M40.872.403c3.635.054 6.763 2.688 6.763 6.322s-3.013 6.712-6.573 6.832a8 8 0 0 1-.445 0c-3.477-.132-6.309-2.968-6.325-6.462 0-.086 0-.177.004-.263.127-3.597 3.062-6.474 6.576-6.425z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#562011",
    d: "M40.877.407c3.634.053 6.762 2.683 6.762 6.318s-3.013 6.712-6.569 6.832a8 8 0 0 1-.444 0c-3.478-.132-6.314-2.964-6.33-6.462 0-.086 0-.177.004-.263.128-3.598 3.062-6.479 6.577-6.425"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572011",
    d: "M40.881.415c3.634.054 6.766 2.68 6.766 6.314s-3.012 6.717-6.568 6.836a8 8 0 0 1-.445 0c-3.478-.128-6.313-2.963-6.33-6.462V6.84C34.432 3.243 37.366.362 40.881.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#582111",
    d: "M40.885.42c3.63.053 6.766 2.679 6.766 6.309s-3.013 6.717-6.568 6.836a8 8 0 0 1-.445 0c-3.482-.128-6.313-2.96-6.33-6.457v-.264C34.436 3.243 37.37.366 40.885.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#592111",
    d: "M40.889.428c3.63.053 6.766 2.675 6.766 6.305s-3.013 6.717-6.568 6.84a8 8 0 0 1-.445 0c-3.482-.127-6.317-2.959-6.334-6.457v-.264C34.436 3.251 37.37.37 40.881.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A2211",
    d: "M40.893.432c3.63.058 6.77 2.671 6.77 6.301s-3.012 6.717-6.568 6.844a8 8 0 0 1-.445 0c-3.481-.123-6.317-2.959-6.334-6.453v-.263C34.444 3.259 37.38.378 40.89.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5B2212",
    d: "M40.897.44c3.63.058 6.77 2.667 6.77 6.301s-3.012 6.72-6.568 6.844a8 8 0 0 1-.445 0c-3.482-.123-6.317-2.955-6.334-6.453v-.263c.128-3.602 3.062-6.483 6.573-6.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C2212",
    d: "M40.902.444c3.63.058 6.77 2.663 6.77 6.297s-3.017 6.721-6.565 6.849a8 8 0 0 1-.444 0c-3.482-.124-6.322-2.956-6.338-6.45v-.263C34.452 3.276 37.387.39 40.897.448z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D2312",
    d: "M40.906.448c3.63.058 6.774 2.659 6.774 6.293s-3.017 6.721-6.564 6.849a8 8 0 0 1-.445 0c-3.482-.124-6.321-2.951-6.338-6.45v-.263C34.461 3.276 37.395.39 40.906.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E2312",
    d: "M40.91.457c3.63.057 6.774 2.658 6.774 6.288s-3.017 6.721-6.564 6.853a8 8 0 0 1-.445 0c-3.482-.12-6.321-2.951-6.342-6.445v-.264c.128-3.605 3.062-6.486 6.573-6.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F2312",
    d: "M40.91.46c3.63.058 6.778 2.655 6.778 6.285s-3.017 6.721-6.564 6.853a8 8 0 0 1-.445 0c-3.482-.12-6.326-2.951-6.342-6.445v-.264C34.464 3.284 37.399.4 40.91.456z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#602413",
    d: "M40.914.469c3.63.057 6.779 2.65 6.779 6.28s-3.017 6.725-6.565 6.857a5 5 0 0 1-.444 0c-3.482-.12-6.326-2.947-6.343-6.44v-.264C34.47 3.296 37.403.412 40.91.469z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#612413",
    d: "M40.918.473c3.63.062 6.778 2.646 6.778 6.276s-3.016 6.725-6.56 6.857a5 5 0 0 1-.444 0c-3.482-.12-6.326-2.947-6.347-6.44v-.264c.128-3.606 3.062-6.49 6.569-6.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#622513",
    d: "M40.922.481c3.63.062 6.783 2.642 6.783 6.272s-3.017 6.725-6.56 6.861c-.149.004-.297.008-.445 0-3.482-.115-6.33-2.943-6.347-6.44V6.91c.128-3.606 3.063-6.49 6.57-6.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#632513",
    d: "M40.926.485c3.626.062 6.783 2.642 6.783 6.268s-3.017 6.725-6.56 6.865a5 5 0 0 1-.445 0c-3.482-.115-6.33-2.942-6.347-6.437v-.263C34.485 3.313 37.42.423 40.926.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#642513",
    d: "M40.93.493c3.626.062 6.783 2.639 6.783 6.265s-3.021 6.729-6.56 6.865c-.149.004-.297.008-.445 0-3.482-.116-6.33-2.943-6.35-6.437v-.264c.127-3.61 3.062-6.494 6.568-6.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#652614",
    d: "M40.934.498c3.626.061 6.787 2.634 6.787 6.264s-3.02 6.729-6.56 6.869c-.148.004-.297.008-.445 0-3.482-.111-6.334-2.939-6.35-6.433v-.263c.127-3.61 3.062-6.495 6.568-6.437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#662614",
    d: "M40.938.506c3.626.062 6.787 2.63 6.787 6.26s-3.02 6.729-6.56 6.869c-.148.004-.297.008-.445 0-3.481-.111-6.334-2.939-6.354-6.433v-.263c.127-3.61 3.062-6.499 6.568-6.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#672614",
    d: "M40.943.51c3.626.062 6.786 2.626 6.786 6.256s-3.02 6.729-6.556 6.873a4 4 0 0 1-.444 0c-3.482-.111-6.334-2.934-6.355-6.429v-.263c.128-3.61 3.062-6.499 6.564-6.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#682714",
    d: "M40.947.514c3.626.066 6.79 2.626 6.79 6.252s-3.02 6.729-6.556 6.873a4 4 0 0 1-.444 0c-3.482-.111-6.338-2.934-6.355-6.429v-.263C34.51 3.337 37.444.448 40.947.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#692714",
    d: "M40.95.522c3.627.066 6.792 2.622 6.792 6.248s-3.021 6.733-6.556 6.877a4 4 0 0 1-.445 0c-3.486-.107-6.338-2.934-6.359-6.424v-.264C34.51 3.35 37.444.457 40.947.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A2815",
    d: "M40.955.527c3.626.065 6.795 2.617 6.795 6.243s-3.02 6.733-6.556 6.877a4 4 0 0 1-.445 0c-3.486-.107-6.338-2.93-6.358-6.424v-.264c.127-3.613 3.062-6.502 6.564-6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B2815",
    d: "M40.96.535c3.625.065 6.794 2.613 6.794 6.239s-3.02 6.733-6.556 6.881a4 4 0 0 1-.445 0c-3.486-.107-6.342-2.93-6.362-6.424v-.264c.123-3.613 3.062-6.502 6.564-6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C2815",
    d: "M40.963.539c3.626.066 6.795 2.609 6.795 6.235s-3.02 6.733-6.552 6.885a4 4 0 0 1-.449 0c-3.486-.107-6.342-2.926-6.362-6.42v-.263C34.518 3.362 37.46.469 40.959.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D2915",
    d: "M40.967.547c3.626.066 6.8 2.61 6.8 6.231s-3.026 6.737-6.553 6.886a4 4 0 0 1-.448 0c-3.486-.103-6.343-2.927-6.363-6.42V6.98c.123-3.614 3.066-6.507 6.56-6.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E2915",
    d: "M40.971.551c3.622.07 6.8 2.605 6.8 6.231s-3.026 6.738-6.553 6.89a4 4 0 0 1-.448 0c-3.486-.103-6.347-2.926-6.367-6.416v-.264c.123-3.613 3.066-6.507 6.56-6.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F2916",
    d: "M40.975.56c3.622.07 6.8 2.6 6.8 6.226s-3.026 6.738-6.553 6.89a4 4 0 0 1-.448 0c-3.486-.103-6.347-2.922-6.367-6.416v-.264C34.53 3.383 37.473.49 40.967.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#702A16",
    d: "M40.976.563c3.621.07 6.803 2.597 6.803 6.223s-3.025 6.738-6.552 6.894a4 4 0 0 1-.449 0c-3.486-.099-6.346-2.922-6.367-6.412v-.26c.124-3.617 3.066-6.51 6.56-6.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#712A16",
    d: "M40.98.572c3.622.07 6.803 2.593 6.803 6.218s-3.025 6.738-6.552 6.894a4 4 0 0 1-.449 0c-3.486-.099-6.35-2.918-6.37-6.412v-.26c.123-3.617 3.065-6.51 6.56-6.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#722B16",
    d: "M40.984.576c3.622.07 6.803 2.589 6.803 6.215s-3.025 6.741-6.548 6.897a5 5 0 0 1-.448.005c-3.486-.1-6.351-2.918-6.372-6.409v-.259c.124-3.617 3.067-6.51 6.56-6.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#732B16",
    d: "M40.988.58c3.622.07 6.807 2.589 6.807 6.21s-3.025 6.742-6.548 6.902a5 5 0 0 1-.449.005c-3.486-.1-6.35-2.918-6.375-6.409V7.03c.124-3.618 3.066-6.515 6.56-6.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#742B17",
    d: "M40.992.588c3.622.07 6.808 2.585 6.808 6.207s-3.025 6.741-6.548 6.902a5 5 0 0 1-.45.004c-3.485-.095-6.354-2.914-6.374-6.408v-.26C34.55 3.416 37.494.518 40.984.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#752C17",
    d: "M40.996.592c3.622.074 6.811 2.58 6.811 6.202s-3.029 6.742-6.548 6.907a5 5 0 0 1-.448.004c-3.486-.095-6.355-2.914-6.376-6.404v-.26C34.56 3.424 37.503.526 40.993.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#762C17",
    d: "M41 .6c3.622.075 6.811 2.577 6.811 6.199s-3.029 6.745-6.548 6.906a5 5 0 0 1-.448.004c-3.486-.095-6.355-2.91-6.38-6.404v-.26C34.56 3.425 37.503.527 40.993.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#772C17",
    d: "M41.004.605c3.622.074 6.812 2.572 6.812 6.194s-3.03 6.745-6.544 6.91a5 5 0 0 1-.449.004c-3.486-.095-6.359-2.91-6.38-6.4v-.26C34.568 3.433 37.51.536 41 .606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#782D17",
    d: "M41.008.613c3.622.074 6.816 2.572 6.816 6.194s-3.03 6.746-6.544 6.91a5 5 0 0 1-.449.004c-3.486-.09-6.358-2.91-6.379-6.4v-.259c.124-3.622 3.066-6.52 6.556-6.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#792D17",
    d: "M41.013.617c3.621.074 6.815 2.568 6.815 6.19s-3.03 6.746-6.544 6.914a5 5 0 0 1-.448.004c-3.486-.09-6.36-2.905-6.384-6.395v-.26C34.576 3.45 37.518.547 41.008.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A2E18",
    d: "M41.017.625c3.618.074 6.815 2.564 6.815 6.186s-3.029 6.75-6.544 6.914a5 5 0 0 1-.448.005c-3.486-.091-6.363-2.906-6.384-6.396v-.26C34.58 3.453 37.524.551 41.01.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7B2E18",
    d: "M41.02.63c3.618.073 6.82 2.56 6.82 6.181s-3.029 6.75-6.543 6.919a5 5 0 0 1-.449.004c-3.49-.087-6.363-2.902-6.388-6.392v-.26C34.584 3.462 37.527.56 41.013.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C2E18",
    d: "M41.025.638c3.618.078 6.82 2.555 6.82 6.177s-3.03 6.75-6.54 6.923a5 5 0 0 1-.449.004c-3.49-.087-6.363-2.902-6.387-6.392v-.259C34.592 3.465 37.535.564 41.02.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D2F18",
    d: "M41.029.642c3.618.078 6.82 2.556 6.82 6.173s-3.03 6.75-6.54 6.923a5 5 0 0 1-.449.004c-3.49-.087-6.367-2.902-6.387-6.388v-.259C34.596 3.47 37.539.568 41.025.642z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E2F18",
    d: "M41.033.646c3.618.078 6.824 2.551 6.824 6.17 0 3.617-3.033 6.749-6.54 6.926q-.224.011-.448.004c-3.49-.087-6.367-2.898-6.392-6.388V7.1C34.6 3.473 37.543.572 41.03.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2F19",
    d: "M41.037.654c3.618.078 6.824 2.548 6.824 6.165s-3.033 6.754-6.54 6.927c-.148.008-.3.008-.448.008-3.49-.082-6.367-2.897-6.392-6.387v-.26C34.604 3.481 37.547.58 41.033.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#803019",
    d: "M41.041.658C44.66.736 47.87 3.202 47.87 6.82c0 3.618-3.033 6.754-6.54 6.931q-.224.01-.448.008c-3.49-.082-6.371-2.897-6.392-6.383v-.26c.124-3.625 3.066-6.53 6.552-6.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#813019",
    d: "M41.042.666c3.617.079 6.828 2.54 6.828 6.157s-3.034 6.754-6.54 6.931q-.224.01-.449.008c-3.49-.082-6.371-2.893-6.396-6.383v-.26C34.61 3.495 37.551.59 41.033.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#823119",
    d: "M41.045.67c3.618.083 6.828 2.536 6.828 6.157s-3.033 6.754-6.535 6.935c-.149.009-.3.009-.45.009-3.49-.079-6.37-2.894-6.395-6.38v-.259C34.617 3.502 37.56.6 41.041.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#833119",
    d: "M41.05.679c3.617.082 6.832 2.535 6.832 6.153s-3.034 6.758-6.536 6.935q-.224.01-.449.008c-3.49-.078-6.375-2.89-6.4-6.38v-.259c.124-3.63 3.067-6.535 6.549-6.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84311A",
    d: "M41.054.683c3.617.082 6.832 2.531 6.832 6.149s-3.034 6.758-6.536 6.939q-.224.013-.449.008c-3.49-.078-6.375-2.89-6.4-6.375v-.26C34.626 3.514 37.569.61 41.05.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85321A",
    d: "M41.058.691c3.614.082 6.832 2.527 6.832 6.145s-3.033 6.758-6.536 6.943q-.224.013-.448.008c-3.49-.078-6.375-2.889-6.4-6.375v-.26c.123-3.63 3.066-6.535 6.548-6.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86321A",
    d: "M41.062.695c3.613.082 6.836 2.523 6.836 6.14 0 3.618-3.037 6.759-6.536 6.944q-.224.013-.448.008c-3.49-.074-6.38-2.885-6.404-6.371v-.26c.123-3.63 3.066-6.54 6.548-6.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87321A",
    d: "M41.066.703c3.614.083 6.836 2.52 6.836 6.137 0 3.618-3.037 6.758-6.531 6.947q-.224.013-.449.008c-3.49-.074-6.38-2.885-6.404-6.37v-.26c.123-3.63 3.066-6.54 6.548-6.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88331A",
    d: "M41.07.708c3.614.082 6.836 2.518 6.836 6.132s-3.037 6.762-6.531 6.947q-.224.013-.449.008c-3.49-.074-6.38-2.88-6.408-6.37v-.26c.12-3.634 3.066-6.54 6.544-6.462z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89331B",
    d: "M41.074.712c3.614.086 6.84 2.514 6.84 6.128s-3.037 6.762-6.53 6.951a6 6 0 0 1-.45.008c-3.49-.074-6.383-2.88-6.408-6.366v-.26C34.646 3.54 37.592.63 41.07.712z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8A331B",
    d: "M41.078.72c3.614.086 6.84 2.51 6.84 6.124s-3.037 6.762-6.531 6.951q-.224.014-.449.009c-3.49-.07-6.383-2.881-6.408-6.367v-.26c.12-3.634 3.066-6.543 6.544-6.461z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B341B",
    d: "M41.083.724c3.613.086 6.844 2.506 6.844 6.124s-3.037 6.762-6.532 6.956a6 6 0 0 1-.448.008c-3.49-.07-6.384-2.877-6.412-6.363v-.26C34.654 3.556 37.6.647 41.079.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C341B",
    d: "M41.087.732C44.7.82 47.93 3.235 47.93 6.852s-3.037 6.766-6.532 6.96a6 6 0 0 1-.448.008c-3.494-.07-6.388-2.877-6.412-6.363v-.26c.119-3.633 3.066-6.543 6.544-6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D351B",
    d: "M41.09.736c3.614.087 6.845 2.503 6.845 6.116 0 3.614-3.037 6.766-6.527 6.96q-.224.013-.449.008c-3.494-.066-6.387-2.873-6.412-6.359v-.259c.12-3.634 3.066-6.548 6.544-6.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E351C",
    d: "M41.095.745c3.613.086 6.848 2.498 6.848 6.111 0 3.614-3.037 6.767-6.527 6.964q-.224.013-.449.008c-3.494-.066-6.387-2.872-6.416-6.358v-.26c.12-3.638 3.066-6.548 6.54-6.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F351C",
    d: "M41.1.749c3.613.086 6.847 2.494 6.847 6.107s-3.04 6.767-6.527 6.964q-.224.013-.449.008c-3.494-.066-6.391-2.872-6.416-6.354v-.26c.12-3.638 3.066-6.548 6.54-6.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90361C",
    d: "M41.103.757c3.61.09 6.849 2.49 6.849 6.104s-3.042 6.766-6.528 6.967q-.224.014-.448.009c-3.495-.066-6.392-2.869-6.42-6.355v-.26C34.674 3.585 37.62.672 41.094.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91361C",
    d: "M41.107.76c3.61.091 6.853 2.487 6.853 6.1 0 3.614-3.041 6.77-6.528 6.968q-.224.014-.448.008c-3.494-.061-6.392-2.868-6.42-6.35v-.26c.119-3.638 3.066-6.552 6.54-6.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92361C",
    d: "M41.107.77c3.61.09 6.853 2.485 6.853 6.095s-3.042 6.77-6.524 6.971q-.224.014-.448.009c-3.494-.062-6.396-2.865-6.42-6.35v-.26c.119-3.638 3.066-6.552 6.54-6.466"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93371D",
    d: "M41.111.773c3.61.09 6.853 2.482 6.853 6.091s-3.042 6.77-6.523 6.972q-.224.014-.45.009c-3.493-.062-6.395-2.865-6.424-6.35v-.26c.12-3.638 3.066-6.556 6.54-6.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#94371D",
    d: "M41.116.777c3.609.091 6.856 2.478 6.856 6.088s-3.041 6.77-6.523 6.976q-.224.013-.449.008c-3.494-.062-6.395-2.865-6.424-6.347v-.259c.119-3.642 3.066-6.556 6.54-6.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95381D",
    d: "M41.12.786c3.609.09 6.856 2.473 6.856 6.087s-3.041 6.774-6.523 6.98q-.224.013-.449.008c-3.494-.057-6.4-2.86-6.424-6.346v-.26C34.699 3.614 37.646.7 41.115.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96381D",
    d: "M41.124.79c3.61.095 6.86 2.47 6.86 6.083s-3.04 6.774-6.523 6.98q-.224.013-.448.008c-3.494-.057-6.4-2.86-6.429-6.342v-.26C34.704 3.618 37.65.7 41.12.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97381D",
    d: "M41.128.798c3.61.095 6.86 2.465 6.86 6.079s-3.041 6.774-6.523 6.984a6 6 0 0 1-.448.008c-3.495-.057-6.4-2.856-6.43-6.342v-.26c.12-3.642 3.067-6.56 6.537-6.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98391D",
    d: "M41.132.802c3.61.095 6.86 2.466 6.86 6.075s-3.045 6.774-6.518 6.984q-.224.013-.449.013c-3.494-.054-6.404-2.857-6.433-6.339v-.259c.12-3.642 3.066-6.56 6.536-6.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99391E",
    d: "M41.136.81c3.61.095 6.865 2.462 6.865 6.071 0 3.61-3.045 6.775-6.519 6.989q-.224.012-.449.012c-3.494-.054-6.404-2.856-6.432-6.338v-.26C34.72 3.642 37.667.724 41.136.81"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A391E",
    d: "M41.14.815c3.61.094 6.865 2.457 6.865 6.066s-3.046 6.779-6.52 6.989c-.147.008-.3.012-.448.012-3.494-.054-6.404-2.852-6.432-6.334v-.26C34.724 3.647 37.67.724 41.14.816"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B3A1E",
    d: "M41.144.823c3.61.095 6.865 2.453 6.865 6.062s-3.045 6.779-6.519 6.993q-.224.012-.449.012c-3.494-.053-6.408-2.852-6.436-6.334v-.26C34.724 3.65 37.675.733 41.14.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C3A1E",
    d: "M41.149.827c3.605.095 6.868 2.449 6.868 6.058s-3.045 6.779-6.519 6.993q-.224.012-.448.012c-3.494-.05-6.408-2.848-6.437-6.334v-.26c.12-3.646 3.07-6.564 6.531-6.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D3B1E",
    d: "M41.153.835c3.605.099 6.869 2.449 6.869 6.054s-3.046 6.779-6.515 6.997q-.224.012-.449.012c-3.494-.05-6.408-2.848-6.437-6.33V7.31c.12-3.647 3.07-6.569 6.532-6.474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E3B1F",
    d: "M41.157.84c3.605.098 6.869 2.444 6.869 6.05s-3.046 6.782-6.515 7q-.224.012-.449.012c-3.498-.05-6.412-2.848-6.44-6.33v-.259c.118-3.646 3.07-6.569 6.53-6.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F3B1F",
    d: "M41.16.848c3.606.098 6.874 2.44 6.874 6.05s-3.045 6.782-6.515 7q-.224.013-.449.013c-3.498-.05-6.412-2.844-6.44-6.326v-.26C34.748 3.68 37.7.758 41.16.849"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A03C1F",
    d: "M41.165.852c3.605.098 6.873 2.436 6.873 6.046 0 3.609-3.05 6.782-6.515 7.004q-.224.013-.449.013c-3.498-.045-6.412-2.844-6.445-6.326v-.26C34.75 3.684 37.7.758 41.161.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A13C1F",
    d: "M41.169.856c3.605.099 6.877 2.432 6.877 6.042s-3.05 6.782-6.515 7.004a8 8 0 0 1-.449.013c-3.498-.045-6.416-2.84-6.445-6.322v-.26c.12-3.65 3.07-6.572 6.532-6.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A23C1F",
    d: "M41.173.864c3.605.099 6.877 2.432 6.877 6.038 0 3.605-3.05 6.782-6.515 7.009q-.224.012-.448.012c-3.499-.045-6.417-2.84-6.445-6.322v-.26c.119-3.65 3.07-6.572 6.527-6.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A33D20",
    d: "M41.173.868C44.778.967 48.05 3.296 48.05 6.9s-3.05 6.787-6.51 7.01q-.225.012-.45.012c-3.498-.041-6.416-2.84-6.448-6.318v-.259c.119-3.65 3.07-6.577 6.527-6.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A43D20",
    d: "M41.177.876C44.783.98 48.06 3.3 48.06 6.906c0 3.605-3.05 6.786-6.511 7.013q-.224.012-.449.012c-3.498-.041-6.42-2.836-6.45-6.317v-.26c.12-3.65 3.071-6.577 6.528-6.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A53E20",
    d: "M41.182.88c3.605.103 6.88 2.42 6.88 6.026s-3.049 6.787-6.51 7.017q-.224.012-.449.012c-3.498-.04-6.42-2.835-6.453-6.313v-.26c.115-3.65 3.07-6.576 6.527-6.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A63E20",
    d: "M41.185.889c3.606.103 6.882 2.416 6.882 6.02 0 3.606-3.05 6.788-6.511 7.018q-.224.012-.449.012c-3.498-.04-6.42-2.831-6.453-6.313v-.26c.115-3.65 3.07-6.58 6.527-6.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A73E20",
    d: "M41.19.893c3.6.103 6.885 2.412 6.885 6.017s-3.05 6.79-6.51 7.021a5 5 0 0 1-.45.013c-3.498-.038-6.424-2.832-6.453-6.314v-.26C34.777 3.717 37.732.79 41.19.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A83F21",
    d: "M41.194.9c3.6.104 6.885 2.413 6.885 6.014s-3.05 6.79-6.507 7.021c-.148.008-.3.017-.449.012-3.498-.036-6.424-2.831-6.457-6.309v-.26c.115-3.654 3.07-6.58 6.528-6.481z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A93F21",
    d: "M41.198.905c3.601.103 6.885 2.408 6.885 6.013s-3.053 6.79-6.506 7.026c-.149.008-.301.016-.45.012-3.497-.037-6.424-2.828-6.457-6.31v-.259c.116-3.655 3.07-6.58 6.524-6.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA3F21",
    d: "M41.202.913c3.601.107 6.89 2.404 6.89 6.01s-3.054 6.79-6.507 7.025c-.148.008-.3.016-.449.012-3.498-.037-6.428-2.828-6.457-6.305v-.26c.115-3.654 3.07-6.585 6.523-6.482"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB4021",
    d: "M41.206.917c3.601.107 6.89 2.4 6.89 6.005s-3.054 6.795-6.507 7.03q-.224.018-.449.012c-3.498-.033-6.428-2.823-6.461-6.305v-.26c.115-3.654 3.07-6.584 6.523-6.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC4021",
    d: "M41.21.922c3.602.107 6.894 2.395 6.894 6s-3.054 6.795-6.507 7.03q-.224.018-.448.012c-3.499-.033-6.43-2.823-6.462-6.301v-.26C34.802 3.75 37.757.82 41.21.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD4122",
    d: "M41.214.93c3.602.107 6.894 2.395 6.894 5.996s-3.054 6.795-6.507 7.034q-.224.018-.448.012c-3.499-.032-6.433-2.823-6.466-6.3v-.26c.115-3.659 3.07-6.59 6.523-6.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE4122",
    d: "M41.218.934c3.601.107 6.894 2.391 6.894 5.992s-3.054 6.795-6.503 7.038q-.224.018-.449.012c-3.498-.029-6.432-2.819-6.465-6.297V7.42c.115-3.659 3.07-6.59 6.523-6.486"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF4122",
    d: "M41.222.942c3.602.107 6.898 2.387 6.898 5.988s-3.054 6.795-6.503 7.038q-.224.019-.448.012c-3.503-.028-6.433-2.819-6.466-6.296v-.26c.115-3.659 3.07-6.589 6.52-6.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B04222",
    d: "M41.226.946c3.602.107 6.898 2.383 6.898 5.984s-3.053 6.8-6.503 7.042q-.224.02-.448.013c-3.503-.03-6.437-2.82-6.47-6.297v-.26c.115-3.658 3.07-6.593 6.52-6.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B14222",
    d: "M41.23.954c3.602.112 6.899 2.38 6.899 5.98 0 3.602-3.058 6.8-6.503 7.042q-.224.018-.449.017c-3.502-.029-6.437-2.815-6.47-6.293v-.26c.116-3.658 3.07-6.593 6.52-6.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B24223",
    d: "M41.235.959c3.597.11 6.902 2.379 6.902 5.98s-3.058 6.799-6.503 7.046q-.224.017-.448.016c-3.503-.024-6.437-2.815-6.47-6.293V7.45C34.83 3.79 37.786.856 41.235.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B34323",
    d: "M41.239.967c3.597.11 6.902 2.374 6.902 5.976 0 3.6-3.058 6.799-6.499 7.046q-.224.017-.448.016c-3.503-.025-6.441-2.81-6.474-6.289v-.259c.115-3.663 3.07-6.597 6.519-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B44323",
    d: "M41.239.97c3.597.112 6.902 2.371 6.902 5.973 0 3.6-3.058 6.803-6.499 7.05q-.224.017-.448.016c-3.503-.024-6.441-2.81-6.474-6.288v-.26c.115-3.663 3.07-6.597 6.519-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B54423",
    d: "M41.243.98c3.597.11 6.906 2.366 6.906 5.967s-3.058 6.803-6.499 7.05q-.224.018-.448.017c-3.503-.021-6.441-2.811-6.478-6.285v-.26c.115-3.662 3.07-6.597 6.519-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B64423",
    d: "M41.247.983c3.597.111 6.906 2.363 6.906 5.964S45.095 13.75 41.655 14q-.224.018-.449.017c-3.502-.021-6.445-2.807-6.478-6.285v-.255c.115-3.663 3.07-6.598 6.515-6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B74424",
    d: "M41.251.987c3.597.111 6.906 2.363 6.906 5.96S45.1 13.75 41.66 14.005q-.224.018-.449.017c-3.502-.02-6.445-2.807-6.478-6.28v-.256c.115-3.663 3.07-6.602 6.515-6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B84524",
    d: "M41.256.996c3.597.115 6.91 2.358 6.91 5.955s-3.058 6.803-6.499 7.058q-.224.018-.449.017c-3.502-.02-6.445-2.803-6.482-6.28V7.49c.116-3.663 3.07-6.601 6.515-6.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B94524",
    d: "M41.26 1c3.597.115 6.91 2.354 6.91 5.95 0 3.598-3.058 6.808-6.495 7.063q-.224.018-.448.017c-3.503-.017-6.45-2.803-6.482-6.28v-.256C34.86 3.827 37.815.893 41.26 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA4524",
    d: "M41.263 1.008c3.598.115 6.915 2.35 6.915 5.947s-3.062 6.807-6.495 7.063q-.224.017-.448.016c-3.503-.016-6.45-2.803-6.483-6.276v-.256c.116-3.667 3.07-6.605 6.515-6.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB4624",
    d: "M41.268 1.012c3.597.115 6.914 2.346 6.914 5.943s-3.062 6.807-6.495 7.067q-.224.017-.448.016c-3.503-.016-6.45-2.799-6.487-6.276v-.255c.116-3.667 3.07-6.606 6.515-6.495"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC4624",
    d: "M41.272 1.02c3.597.115 6.914 2.342 6.914 5.943 0 3.602-3.062 6.808-6.494 7.067q-.224.017-.449.016c-3.502-.016-6.453-2.798-6.486-6.272V7.52c.115-3.667 3.07-6.606 6.515-6.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD4725",
    d: "M41.276 1.024c3.593.116 6.918 2.342 6.918 5.94 0 3.596-3.062 6.81-6.494 7.07q-.224.017-.449.016c-3.502-.012-6.453-2.794-6.49-6.272v-.255c.115-3.667 3.07-6.61 6.51-6.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE4725",
    d: "M41.28 1.033c3.593.12 6.918 2.337 6.918 5.935s-3.062 6.811-6.49 7.074q-.224.018-.449.017c-3.502-.012-6.453-2.795-6.49-6.268v-.256c.115-3.667 3.07-6.61 6.511-6.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BF4725",
    d: "M41.284 1.037c3.593.12 6.919 2.333 6.919 5.93 0 3.598-3.062 6.812-6.49 7.075q-.225.018-.45.017c-3.502-.013-6.457-2.795-6.49-6.268v-.256c.116-3.67 3.07-6.61 6.511-6.498"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C04825",
    d: "M41.288 1.045c3.593.12 6.923 2.33 6.923 5.926 0 3.598-3.062 6.812-6.49 7.08q-.225.017-.45.016c-3.502-.008-6.457-2.79-6.494-6.264v-.255c.116-3.671 3.07-6.614 6.511-6.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C14825",
    d: "M41.292 1.05c3.593.119 6.923 2.325 6.923 5.922s-3.062 6.811-6.49 7.079q-.225.017-.45.016c-3.506-.008-6.457-2.79-6.494-6.264v-.255c.116-3.671 3.07-6.614 6.511-6.499"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C24826",
    d: "M41.296 1.053c3.593.12 6.923 2.326 6.923 5.919s-3.066 6.815-6.49 7.083q-.225.017-.45.016c-3.506-.008-6.46-2.786-6.498-6.26v-.255c.111-3.671 3.07-6.614 6.511-6.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C34926",
    d: "M41.3 1.061c3.594.12 6.927 2.322 6.927 5.915s-3.066 6.815-6.49 7.083q-.224.017-.449.016c-3.506-.008-6.461-2.786-6.498-6.26V7.56c.11-3.671 3.07-6.614 6.506-6.499z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C44926",
    d: "M41.305 1.065c3.593.12 6.927 2.318 6.927 5.91 0 3.594-3.067 6.816-6.487 7.088a6 6 0 0 1-.452.016c-3.507-.004-6.462-2.786-6.5-6.26v-.255c.112-3.671 3.071-6.618 6.508-6.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C54A26",
    d: "M41.305 1.074c3.593.123 6.93 2.313 6.93 5.906s-3.065 6.815-6.486 7.087a6 6 0 0 1-.452.016c-3.507-.004-6.466-2.782-6.503-6.255v-.256c.111-3.675 3.07-6.618 6.507-6.502z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C64A26",
    d: "M41.309 1.078c3.593.123 6.93 2.309 6.93 5.906s-3.066 6.82-6.486 7.091q-.223.018-.452.017c-3.507 0-6.466-2.783-6.503-6.256V7.58c.111-3.676 3.07-6.618 6.507-6.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C74A27",
    d: "M41.313 1.086c3.593.124 6.931 2.31 6.931 5.902s-3.066 6.82-6.486 7.096a6 6 0 0 1-.453.016c-3.507 0-6.466-2.778-6.503-6.252v-.255c.111-3.675 3.07-6.622 6.507-6.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C84B27",
    d: "M41.317 1.09c3.593.124 6.935 2.305 6.935 5.898s-3.066 6.82-6.486 7.095q-.223.018-.453.017c-3.507 0-6.47-2.778-6.507-6.252v-.255c.111-3.675 3.07-6.622 6.507-6.503z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94B27",
    d: "M48.256 6.992c0 3.593-3.342 7.116-6.935 7.116s-6.614-2.914-6.507-6.507c.111-3.675 3.075-6.622 6.507-6.503 3.589.124 6.935 2.301 6.935 5.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94C28",
    d: "M41.326 1.103C44.914 1.226 48.26 3.407 48.26 7s-3.341 7.112-6.934 7.112-6.614-2.914-6.507-6.507c.11-3.675 3.07-6.622 6.506-6.502"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA4D29",
    d: "M41.33 1.107c3.588.123 6.93 2.305 6.93 5.898s-3.338 7.111-6.93 7.111c-3.593 0-6.614-2.913-6.507-6.506.11-3.676 3.07-6.623 6.506-6.503",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E2A",
    d: "M41.33 1.11c3.588.124 6.93 2.31 6.93 5.903s-3.338 7.108-6.93 7.108c-3.593 0-6.614-2.914-6.507-6.507.11-3.676 3.07-6.622 6.506-6.503",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E2B",
    d: "M41.334 1.115c3.589.124 6.926 2.313 6.926 5.906s-3.333 7.104-6.926 7.104-6.614-2.914-6.507-6.507c.111-3.675 3.07-6.622 6.507-6.503",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CA4F2C",
    d: "M41.338 1.119c3.589.12 6.926 2.313 6.926 5.906s-3.333 7.104-6.926 7.104-6.614-2.914-6.507-6.507C34.942 3.946 37.9 1 41.338 1.119",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB502D",
    d: "M41.338 1.123c3.588.12 6.922 2.317 6.922 5.91s-3.33 7.1-6.922 7.1c-3.593 0-6.61-2.914-6.507-6.507.107-3.675 3.066-6.622 6.506-6.503",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB512E",
    d: "M41.342 1.127c3.589.12 6.922 2.322 6.922 5.915s-3.33 7.095-6.922 7.095c-3.593 0-6.61-2.914-6.507-6.507.107-3.675 3.066-6.618 6.507-6.503",
    opacity: 0.97
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB522F",
    d: "M41.346 1.131c3.589.12 6.918 2.322 6.918 5.915s-3.325 7.095-6.918 7.095-6.61-2.914-6.507-6.507c.107-3.671 3.066-6.618 6.507-6.503",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB5330",
    d: "M41.346 1.136c3.589.119 6.918 2.325 6.918 5.918s-3.325 7.091-6.918 7.091-6.61-2.914-6.507-6.507c.107-3.67 3.066-6.618 6.507-6.502",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC5331",
    d: "M41.35 1.14c3.59.12 6.914 2.33 6.914 5.922 0 3.593-3.32 7.087-6.914 7.087s-6.61-2.913-6.507-6.506C34.95 3.97 37.91 1.025 41.35 1.14",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC5432",
    d: "M41.354 1.144c3.589.12 6.915 2.333 6.915 5.922 0 3.59-3.322 7.087-6.915 7.087s-6.61-2.913-6.507-6.506c.107-3.672 3.066-6.618 6.507-6.503",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C53",
    d: "M41.354 1.148c3.589.12 6.91 2.333 6.91 5.926s-3.317 7.083-6.91 7.083-6.61-2.914-6.507-6.506c.107-3.672 3.062-6.618 6.507-6.503",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC5634",
    d: "M41.359 1.152c3.588.115 6.91 2.338 6.91 5.93 0 3.594-3.317 7.08-6.91 7.08s-6.61-2.914-6.507-6.507c.107-3.671 3.062-6.618 6.507-6.503",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5735",
    d: "M41.362 1.156c3.59.115 6.906 2.342 6.906 5.935s-3.313 7.079-6.906 7.079-6.605-2.914-6.507-6.507c.103-3.671 3.062-6.614 6.507-6.503z",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5836",
    d: "M41.367 1.16c3.589.116 6.906 2.342 6.906 5.935s-3.313 7.075-6.906 7.075-6.606-2.914-6.507-6.507c.103-3.671 3.062-6.614 6.507-6.503",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5837",
    d: "M41.367 1.164c3.589.116 6.902 2.346 6.902 5.94 0 3.592-3.31 7.07-6.902 7.07S34.76 11.26 34.86 7.667c.103-3.671 3.062-6.614 6.507-6.503",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD5938",
    d: "M41.37 1.169c3.59.115 6.903 2.35 6.903 5.943s-3.31 7.066-6.903 7.066-6.605-2.914-6.506-6.507c.103-3.67 3.058-6.614 6.507-6.502",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5A39",
    d: "M41.375 1.172c3.589.116 6.898 2.35 6.898 5.944s-3.305 7.066-6.898 7.066-6.606-2.914-6.507-6.507c.103-3.67 3.058-6.614 6.507-6.503",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5B3A",
    d: "M41.375 1.177c3.589.115 6.898 2.354 6.898 5.947s-3.305 7.062-6.898 7.062-6.606-2.914-6.507-6.507c.103-3.667 3.058-6.613 6.507-6.502",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5C3B",
    d: "M41.379 1.18c3.589.112 6.894 2.36 6.894 5.952s-3.301 7.058-6.894 7.058-6.606-2.913-6.507-6.506c.103-3.668 3.058-6.614 6.507-6.503",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE5D3C",
    d: "M41.383 1.185c3.59.111 6.894 2.358 6.894 5.951s-3.3 7.059-6.894 7.059c-3.593 0-6.605-2.914-6.507-6.507.103-3.667 3.058-6.614 6.507-6.503",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5D3D",
    d: "M41.383 1.19c3.589.11 6.89 2.362 6.89 5.954 0 3.594-3.297 7.055-6.89 7.055s-6.602-2.914-6.507-6.507c.099-3.667 3.058-6.61 6.507-6.503",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5E3E",
    d: "M41.387 1.193c3.589.111 6.89 2.367 6.89 5.96s-3.297 7.05-6.89 7.05-6.602-2.914-6.507-6.507c.099-3.667 3.054-6.61 6.507-6.503",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF5F3F",
    d: "M41.391 1.197c3.59.111 6.886 2.367 6.886 5.96s-3.293 7.05-6.886 7.05-6.601-2.914-6.506-6.507c.098-3.667 3.053-6.61 6.506-6.503",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF6040",
    d: "M41.391 1.201c3.59.111 6.886 2.37 6.886 5.964 0 3.593-3.293 7.046-6.886 7.046s-6.601-2.914-6.506-6.507c.098-3.667 3.053-6.61 6.506-6.503",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D06141",
    d: "M41.395 1.205c3.59.112 6.882 2.375 6.882 5.968s-3.289 7.042-6.882 7.042-6.601-2.914-6.507-6.507c.1-3.667 3.054-6.61 6.507-6.503",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D06242",
    d: "M41.4 1.21c3.589.107 6.881 2.378 6.881 5.967 0 3.59-3.288 7.042-6.881 7.042s-6.602-2.914-6.507-6.507c.099-3.667 3.054-6.61 6.507-6.502",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D06243",
    d: "M41.4 1.218c3.589.107 6.877 2.379 6.877 5.972s-3.288 7.038-6.877 7.038-6.602-2.914-6.507-6.507c.099-3.667 3.05-6.61 6.507-6.503",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D06344",
    d: "M41.404 1.222c3.588.107 6.877 2.383 6.877 5.976s-3.285 7.034-6.877 7.034c-3.593 0-6.602-2.914-6.507-6.507.099-3.663 3.05-6.606 6.507-6.503",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D16445",
    d: "M41.408 1.226c3.593.107 6.873 2.387 6.873 5.98s-3.284 7.034-6.873 7.034-6.598-2.914-6.507-6.507c.095-3.663 3.05-6.606 6.507-6.503z",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D16546",
    d: "M41.412 1.23c3.593.107 6.873 2.387 6.873 5.98s-3.28 7.03-6.873 7.03-6.598-2.914-6.507-6.507c.094-3.663 3.05-6.606 6.507-6.503",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D16647",
    d: "M41.412 1.234c3.593.107 6.873 2.392 6.873 5.985s-3.28 7.025-6.873 7.025-6.598-2.914-6.507-6.507c.094-3.663 3.05-6.606 6.507-6.503",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D16748",
    d: "M41.416 1.238c3.593.107 6.87 2.396 6.87 5.989s-3.277 7.021-6.87 7.021-6.597-2.914-6.507-6.507c.095-3.663 3.05-6.605 6.507-6.503",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D26749",
    d: "M41.42 1.243c3.593.102 6.869 2.395 6.869 5.988s-3.276 7.021-6.869 7.021-6.597-2.914-6.507-6.507c.095-3.663 3.046-6.605 6.507-6.502",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2684A",
    d: "M41.42 1.247c3.593.103 6.865 2.4 6.865 5.992s-3.272 7.017-6.865 7.017-6.597-2.914-6.507-6.506c.095-3.663 3.046-6.606 6.507-6.503",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2694B",
    d: "M41.424 1.25c3.593.104 6.865 2.404 6.865 5.997s-3.272 7.013-6.865 7.013-6.597-2.914-6.507-6.507c.095-3.663 3.046-6.605 6.507-6.502",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D26A4C",
    d: "M41.428 1.255c3.593.103 6.861 2.403 6.861 5.996s-3.268 7.014-6.86 7.014c-3.594 0-6.598-2.914-6.508-6.507.095-3.663 3.046-6.602 6.507-6.503",
    opacity: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D36B4D",
    d: "M41.428 1.259c3.593.103 6.86 2.408 6.86 6 0 3.594-3.267 7.01-6.86 7.01s-6.593-2.914-6.507-6.507c.09-3.663 3.046-6.602 6.507-6.503",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D36C4E",
    d: "M41.433 1.263c3.593.103 6.856 2.412 6.856 6.005s-3.264 7.005-6.857 7.005-6.593-2.914-6.506-6.507c.09-3.663 3.041-6.602 6.506-6.503",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D36C4F",
    d: "M41.436 1.267c3.593.103 6.857 2.412 6.857 6.005s-3.264 7.005-6.857 7.005-6.593-2.914-6.506-6.507c.09-3.659 3.041-6.601 6.506-6.503",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D36D50",
    d: "M41.436 1.271c3.593.1 6.853 2.416 6.853 6.01 0 3.592-3.26 7-6.853 7s-6.593-2.914-6.506-6.507c.09-3.659 3.041-6.601 6.506-6.503",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D46E51",
    d: "M41.44 1.275c3.594.1 6.853 2.42 6.853 6.013s-3.26 6.997-6.852 6.997-6.594-2.914-6.507-6.507c.09-3.659 3.041-6.601 6.507-6.503",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D46F52",
    d: "M41.445 1.28c3.593.098 6.848 2.424 6.848 6.013s-3.255 6.996-6.848 6.996-6.594-2.914-6.507-6.507c.09-3.659 3.041-6.601 6.507-6.502",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D47053",
    d: "M41.445 1.284c3.593.098 6.848 2.424 6.848 6.017s-3.255 6.992-6.848 6.992-6.594-2.913-6.507-6.507c.09-3.658 3.041-6.597 6.507-6.502",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D47154",
    d: "M41.449 1.288c3.593.099 6.844 2.428 6.844 6.021s-3.251 6.988-6.844 6.988-6.594-2.913-6.507-6.506c.09-3.66 3.037-6.598 6.507-6.503",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D57155",
    d: "M41.453 1.292c3.593.099 6.844 2.432 6.844 6.025s-3.251 6.989-6.844 6.989-6.59-2.914-6.507-6.507c.086-3.659 3.037-6.598 6.507-6.503z",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D57256",
    d: "M41.453 1.296c3.593.099 6.84 2.433 6.84 6.026s-3.247 6.984-6.84 6.984-6.59-2.914-6.507-6.507c.086-3.659 3.037-6.597 6.507-6.503",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D57357",
    d: "M41.457 1.3c3.593.095 6.84 2.437 6.84 6.03 0 3.592-3.247 6.98-6.84 6.98s-6.589-2.914-6.507-6.507c.087-3.659 3.038-6.598 6.507-6.503",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D57458",
    d: "M41.461 1.304c3.593.095 6.836 2.44 6.836 6.034s-3.243 6.976-6.836 6.976-6.589-2.914-6.507-6.507c.087-3.659 3.038-6.597 6.507-6.503",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D67559",
    d: "M41.466 1.308c3.593.095 6.836 2.441 6.836 6.034s-3.243 6.976-6.837 6.976c-3.592 0-6.589-2.914-6.506-6.507.086-3.659 3.037-6.597 6.506-6.503",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6765A",
    d: "M41.466 1.313c3.593.094 6.831 2.444 6.831 6.037s-3.238 6.972-6.831 6.972-6.59-2.914-6.507-6.507c.086-3.654 3.033-6.597 6.506-6.502",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6765B",
    d: "M41.47 1.317c3.592.094 6.831 2.449 6.831 6.042s-3.239 6.967-6.832 6.967-6.589-2.914-6.506-6.507c.086-3.654 3.033-6.593 6.506-6.502",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6775C",
    d: "M41.473 1.32c3.593.095 6.828 2.45 6.828 6.042 0 3.593-3.235 6.968-6.828 6.968s-6.589-2.914-6.506-6.507C35.053 4.17 38 1.23 41.473 1.321",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7785D",
    d: "M41.473 1.325c3.593.094 6.828 2.453 6.828 6.046s-3.235 6.963-6.828 6.963-6.589-2.913-6.506-6.506c.082-3.655 3.033-6.594 6.506-6.503",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7795E",
    d: "M41.478 1.329c3.593.095 6.823 2.457 6.823 6.05s-3.23 6.96-6.823 6.96-6.586-2.914-6.507-6.507c.082-3.655 3.033-6.594 6.507-6.503",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D77A5F",
    d: "M41.482 1.333c3.593.09 6.824 2.457 6.824 6.05s-3.231 6.96-6.824 6.96-6.585-2.914-6.507-6.507c.082-3.655 3.03-6.593 6.507-6.503",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D77B60",
    d: "M41.482 1.337c3.593.09 6.82 2.461 6.82 6.054s-3.227 6.956-6.82 6.956-6.585-2.914-6.507-6.507c.082-3.655 3.03-6.593 6.507-6.503",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D87B61",
    d: "M41.486 1.341c3.593.09 6.82 2.466 6.82 6.059s-3.227 6.951-6.82 6.951-6.585-2.914-6.507-6.507c.082-3.655 3.03-6.593 6.507-6.503",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D87C62",
    d: "M41.49 1.345c3.593.09 6.815 2.47 6.815 6.059s-3.226 6.951-6.815 6.951-6.585-2.914-6.507-6.507c.082-3.655 3.03-6.59 6.507-6.503",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D87D63",
    d: "M41.49 1.35c3.593.09 6.815 2.469 6.815 6.062s-3.222 6.947-6.815 6.947-6.585-2.914-6.507-6.507c.082-3.654 3.03-6.589 6.507-6.502",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D87E64",
    d: "M41.494 1.358c3.593.09 6.812 2.473 6.812 6.066s-3.223 6.943-6.812 6.943-6.585-2.913-6.507-6.506c.083-3.651 3.03-6.59 6.507-6.503",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D97F65",
    d: "M41.498 1.362c3.593.09 6.812 2.477 6.812 6.07s-3.219 6.944-6.812 6.944-6.585-2.914-6.507-6.507c.078-3.65 3.025-6.59 6.507-6.503z",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D98066",
    d: "M41.498 1.366c3.593.087 6.812 2.478 6.812 6.07 0 3.594-3.219 6.94-6.812 6.94-3.592 0-6.58-2.914-6.506-6.507.078-3.65 3.025-6.59 6.506-6.503",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D98067",
    d: "M41.502 1.37c3.593.086 6.808 2.482 6.808 6.075s-3.215 6.935-6.808 6.935-6.58-2.914-6.507-6.507c.079-3.65 3.026-6.59 6.507-6.503",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D98168",
    d: "M41.506 1.374c3.593.087 6.808 2.486 6.808 6.079s-3.215 6.93-6.808 6.93S34.926 11.47 35 7.878c.079-3.65 3.025-6.59 6.507-6.503",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA8269",
    d: "M41.51 1.378c3.594.087 6.804 2.486 6.804 6.08 0 3.592-3.21 6.93-6.803 6.93s-6.581-2.914-6.507-6.507c.078-3.65 3.025-6.59 6.507-6.503",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA836A",
    d: "M41.51 1.383c3.594.086 6.804 2.49 6.804 6.083s-3.21 6.926-6.803 6.926-6.581-2.914-6.507-6.507c.078-3.65 3.02-6.585 6.507-6.502",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA846B",
    d: "M41.515 1.387c3.593.086 6.799 2.494 6.799 6.087s-3.206 6.922-6.8 6.922c-3.592 0-6.58-2.914-6.506-6.507.078-3.65 3.02-6.585 6.507-6.502",
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA856C",
    d: "M41.519 1.39c3.593.087 6.799 2.495 6.799 6.088s-3.206 6.922-6.8 6.922c-3.592 0-6.58-2.914-6.506-6.507.078-3.65 3.021-6.585 6.507-6.502",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB856D",
    d: "M41.519 1.395c3.593.082 6.795 2.498 6.795 6.091s-3.202 6.918-6.795 6.918-6.581-2.913-6.507-6.506c.074-3.651 3.021-6.586 6.507-6.503",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB866E",
    d: "M41.523 1.399c3.593.082 6.795 2.502 6.795 6.095s-3.202 6.915-6.795 6.915-6.577-2.914-6.507-6.507c.074-3.65 3.02-6.585 6.507-6.503",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB876F",
    d: "M41.527 1.403c3.593.082 6.791 2.502 6.791 6.095s-3.198 6.915-6.79 6.915c-3.594 0-6.578-2.914-6.508-6.507.074-3.647 3.021-6.585 6.507-6.503",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB8870",
    d: "M41.527 1.407c3.593.083 6.791 2.507 6.791 6.1s-3.198 6.91-6.79 6.91c-3.594 0-6.578-2.914-6.508-6.507.074-3.647 3.017-6.585 6.507-6.503",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC8971",
    d: "M41.531 1.411c3.593.083 6.787 2.51 6.787 6.104 0 3.593-3.194 6.906-6.787 6.906s-6.577-2.914-6.507-6.507c.074-3.647 3.017-6.581 6.507-6.503",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC8A72",
    d: "M41.535 1.415c3.593.083 6.787 2.515 6.787 6.104s-3.194 6.906-6.787 6.906-6.576-2.914-6.506-6.507c.074-3.646 3.016-6.58 6.506-6.503",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC8A73",
    d: "M41.535 1.42c3.593.082 6.783 2.514 6.783 6.107s-3.19 6.902-6.783 6.902-6.576-2.914-6.506-6.507c.074-3.646 3.016-6.58 6.506-6.502",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC8B74",
    d: "M41.54 1.424c3.592.078 6.782 2.518 6.782 6.111s-3.19 6.898-6.783 6.898-6.577-2.914-6.507-6.507c.075-3.646 3.017-6.58 6.507-6.502",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD8C75",
    d: "M41.544 1.428c3.593.078 6.778 2.523 6.778 6.116s-3.185 6.893-6.778 6.893-6.577-2.913-6.507-6.506c.07-3.647 3.013-6.581 6.507-6.503",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD8D76",
    d: "M41.544 1.432c3.593.078 6.778 2.523 6.778 6.116s-3.186 6.894-6.778 6.894c-3.593 0-6.573-2.914-6.507-6.507.07-3.647 3.012-6.581 6.507-6.503",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD8E77",
    d: "M41.548 1.436c3.593.078 6.774 2.527 6.774 6.12s-3.181 6.89-6.775 6.89c-3.592 0-6.572-2.914-6.506-6.507.07-3.647 3.012-6.581 6.507-6.503",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD8F78",
    d: "M41.552 1.44c3.593.078 6.774 2.531 6.774 6.124s-3.181 6.886-6.774 6.886-6.573-2.914-6.507-6.507c.07-3.647 3.013-6.581 6.507-6.503",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE8F79",
    d: "M41.556 1.444c3.593.078 6.77 2.531 6.77 6.124s-3.177 6.886-6.77 6.886-6.573-2.914-6.507-6.507c.07-3.642 3.013-6.577 6.507-6.503",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE907A",
    d: "M41.556 1.448c3.593.079 6.77 2.536 6.77 6.129s-3.177 6.881-6.77 6.881-6.573-2.914-6.507-6.507c.07-3.642 3.013-6.577 6.507-6.503",
    opacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE917B",
    d: "M41.56 1.453c3.593.074 6.766 2.539 6.766 6.132s-3.173 6.877-6.766 6.877-6.573-2.914-6.507-6.507c.07-3.642 3.009-6.577 6.507-6.502",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE927C",
    d: "M41.564 1.456c3.593.075 6.766 2.54 6.766 6.133s-3.173 6.877-6.766 6.877-6.573-2.914-6.507-6.507c.07-3.642 3.009-6.577 6.507-6.503",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF937D",
    d: "M41.564 1.46c3.593.075 6.762 2.544 6.762 6.137s-3.169 6.873-6.762 6.873-6.573-2.914-6.507-6.507c.066-3.642 3.009-6.576 6.507-6.502",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF947E",
    d: "M41.568 1.465c3.593.074 6.762 2.547 6.762 6.14s-3.169 6.87-6.762 6.87S35 11.56 35.062 7.967c.065-3.643 3.008-6.577 6.506-6.503",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF947F",
    d: "M41.572 1.469c3.593.074 6.758 2.552 6.758 6.14 0 3.59-3.165 6.87-6.758 6.87s-6.568-2.914-6.507-6.507c.066-3.643 3.009-6.577 6.507-6.503",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF9580",
    d: "M41.572 1.473c3.593.074 6.758 2.552 6.758 6.145s-3.165 6.865-6.758 6.865-6.568-2.914-6.507-6.507c.066-3.642 3.005-6.573 6.507-6.503",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E09681",
    d: "M41.577 1.477c3.593.074 6.753 2.556 6.753 6.149s-3.164 6.86-6.753 6.86-6.569-2.913-6.507-6.506c.066-3.643 3.004-6.573 6.507-6.503",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E09782",
    d: "M41.58 1.481c3.593.07 6.754 2.56 6.754 6.149s-3.16 6.86-6.753 6.86-6.569-2.913-6.507-6.506c.066-3.642 3.004-6.573 6.507-6.503",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E09883",
    d: "M41.58 1.485c3.593.07 6.75 2.56 6.75 6.153s-3.16 6.857-6.75 6.857c-3.588 0-6.568-2.914-6.506-6.507.066-3.642 3.004-6.573 6.507-6.503",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E09984",
    d: "M41.585 1.49c3.592.07 6.75 2.564 6.75 6.157s-3.158 6.852-6.75 6.852-6.57-2.914-6.507-6.507c.066-3.638 3.004-6.572 6.506-6.502",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E19985",
    d: "M41.589 1.494c3.593.07 6.75 2.568 6.75 6.16 0 3.594-3.157 6.85-6.75 6.85s-6.569-2.915-6.507-6.508c.062-3.638 3.004-6.572 6.507-6.502",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E19A86",
    d: "M41.589 1.502c3.593.07 6.745 2.568 6.745 6.161s-3.152 6.849-6.745 6.849-6.565-2.914-6.507-6.507c.062-3.639 3-6.573 6.507-6.503",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E19B87",
    d: "M41.593 1.506c3.593.07 6.746 2.572 6.746 6.165s-3.153 6.844-6.746 6.844-6.564-2.913-6.507-6.506c.062-3.639 3-6.573 6.507-6.503",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E19C88",
    d: "M41.597 1.51c3.593.07 6.742 2.577 6.742 6.17s-3.149 6.84-6.742 6.84-6.564-2.914-6.507-6.507c.062-3.638 3-6.569 6.507-6.503",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E29D89",
    d: "M41.6 1.514c3.594.066 6.742 2.577 6.742 6.17s-3.148 6.84-6.741 6.84-6.565-2.914-6.507-6.507c.062-3.638 3-6.569 6.507-6.503",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E29E8A",
    d: "M41.6 1.518c3.594.066 6.738 2.581 6.738 6.174s-3.144 6.836-6.737 6.836-6.565-2.914-6.507-6.507c.062-3.638 3-6.568 6.507-6.503",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E29E8B",
    d: "M41.605 1.522c3.593.066 6.738 2.585 6.738 6.178s-3.145 6.832-6.738 6.832-6.564-2.914-6.506-6.507c.061-3.638 3-6.569 6.506-6.503",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E29F8C",
    d: "M41.61 1.526c3.592.066 6.733 2.585 6.733 6.178s-3.14 6.832-6.734 6.832-6.564-2.914-6.507-6.507c.062-3.638 2.997-6.568 6.507-6.503",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A08D",
    d: "M41.61 1.53c3.592.066 6.733 2.59 6.733 6.182s-3.14 6.828-6.734 6.828-6.564-2.914-6.507-6.507c.058-3.638 2.997-6.568 6.507-6.502",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A18E",
    d: "M41.614 1.535c3.593.066 6.729 2.593 6.729 6.186s-3.137 6.823-6.73 6.823c-3.592 0-6.56-2.914-6.506-6.506.057-3.639 2.996-6.57 6.507-6.503",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A28F",
    d: "M41.617 1.539c3.593.066 6.73 2.597 6.73 6.186s-3.137 6.823-6.73 6.823c-3.592 0-6.56-2.914-6.506-6.506.057-3.635 2.996-6.565 6.506-6.503",
    opacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A390",
    d: "M41.617 1.543c3.593.066 6.725 2.597 6.725 6.19s-3.132 6.82-6.725 6.82-6.56-2.914-6.506-6.507c.057-3.634 2.996-6.565 6.506-6.503",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A391",
    d: "M41.622 1.547c3.593.062 6.725 2.601 6.725 6.194s-3.132 6.816-6.725 6.816-6.56-2.914-6.507-6.507c.058-3.634 2.992-6.565 6.507-6.503",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A492",
    d: "M41.626 1.551c3.593.062 6.72 2.605 6.72 6.194s-3.127 6.816-6.72 6.816-6.56-2.914-6.507-6.507c.057-3.634 2.992-6.564 6.507-6.503",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A593",
    d: "M41.626 1.555c3.593.062 6.72 2.606 6.72 6.199s-3.127 6.811-6.72 6.811-6.56-2.914-6.507-6.507c.057-3.634 2.992-6.564 6.507-6.503",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A694",
    d: "M41.63 1.56c3.593.061 6.717 2.609 6.717 6.202s-3.124 6.807-6.717 6.807-6.56-2.914-6.507-6.507c.054-3.634 2.992-6.564 6.507-6.502",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4A795",
    d: "M41.634 1.563c3.593.062 6.717 2.614 6.717 6.207s-3.124 6.803-6.717 6.803-6.56-2.914-6.507-6.507c.054-3.634 2.992-6.564 6.507-6.503",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A796",
    d: "M41.634 1.568c3.593.061 6.713 2.613 6.713 6.206s-3.12 6.803-6.713 6.803-6.556-2.914-6.507-6.507c.054-3.634 2.992-6.564 6.507-6.502",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A897",
    d: "M41.638 1.572c3.593.062 6.713 2.617 6.713 6.21s-3.12 6.8-6.713 6.8-6.556-2.914-6.506-6.507c.053-3.634 2.987-6.56 6.506-6.503",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5A998",
    d: "M41.642 1.576c3.593.058 6.709 2.622 6.709 6.215s-3.116 6.795-6.709 6.795-6.556-2.914-6.507-6.507c.054-3.634 2.988-6.56 6.507-6.503",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5AA99",
    d: "M41.647 1.58c3.593.058 6.708 2.622 6.708 6.215s-3.115 6.795-6.708 6.795-6.557-2.914-6.507-6.507c.053-3.63 2.988-6.56 6.507-6.503",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AB9A",
    d: "M41.647 1.584c3.593.058 6.704 2.626 6.704 6.219s-3.111 6.79-6.704 6.79-6.557-2.913-6.507-6.506c.053-3.63 2.988-6.56 6.507-6.503",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AC9B",
    d: "M41.65 1.588c3.593.058 6.705 2.63 6.705 6.223s-3.111 6.787-6.704 6.787-6.557-2.914-6.507-6.507c.053-3.63 2.988-6.56 6.507-6.503",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AC9C",
    d: "M41.654 1.592c3.593.058 6.7 2.63 6.7 6.223s-3.107 6.787-6.7 6.787-6.556-2.914-6.506-6.507c.049-3.63 2.983-6.56 6.506-6.503",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6AD9D",
    d: "M41.654 1.597c3.593.057 6.7 2.634 6.7 6.227 0 3.592-3.107 6.782-6.7 6.782s-6.556-2.914-6.506-6.507c.049-3.63 2.983-6.56 6.506-6.502",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7AE9E",
    d: "M41.659 1.6c3.593.058 6.696 2.639 6.696 6.232s-3.103 6.778-6.696 6.778-6.552-2.914-6.507-6.507c.05-3.63 2.984-6.556 6.507-6.502",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7AF9F",
    d: "M41.663 1.605c3.593.053 6.696 2.642 6.696 6.23 0 3.59-3.103 6.78-6.696 6.78S35.11 11.7 35.156 8.106c.05-3.63 2.984-6.556 6.507-6.502",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7B0A0",
    d: "M41.663 1.609c3.593.053 6.692 2.642 6.692 6.235s-3.103 6.774-6.692 6.774-6.552-2.913-6.507-6.506c.05-3.63 2.984-6.557 6.507-6.503",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7B1A1",
    d: "M41.667 1.613c3.593.054 6.692 2.646 6.692 6.24 0 3.592-3.099 6.77-6.692 6.77s-6.552-2.914-6.507-6.507c.05-3.63 2.984-6.556 6.507-6.503",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8B1A2",
    d: "M41.67 1.617c3.594.054 6.689 2.65 6.689 6.24 0 3.588-3.1 6.77-6.688 6.77-3.589 0-6.552-2.914-6.507-6.507.05-3.63 2.98-6.556 6.507-6.503",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8B2A3",
    d: "M41.67 1.621c3.594.054 6.689 2.65 6.689 6.244 0 3.592-3.095 6.766-6.688 6.766s-6.552-2.914-6.507-6.507c.05-3.63 2.98-6.556 6.507-6.503",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8B3A4",
    d: "M41.675 1.625c3.593.054 6.688 2.655 6.688 6.248s-3.095 6.762-6.688 6.762-6.552-2.914-6.506-6.507c.045-3.626 2.98-6.556 6.506-6.503",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8B4A5",
    d: "M41.68 1.63c3.592.053 6.683 2.658 6.683 6.251s-3.09 6.758-6.684 6.758c-3.593 0-6.552-2.914-6.507-6.507.046-3.626 2.98-6.552 6.507-6.502",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9B5A6",
    d: "M41.68 1.633c3.592.05 6.683 2.66 6.683 6.252 0 3.593-3.09 6.758-6.684 6.758-3.593 0-6.548-2.914-6.507-6.507.046-3.626 2.98-6.552 6.507-6.503",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9B6A7",
    d: "M41.684 1.642c3.593.05 6.68 2.663 6.68 6.256s-3.087 6.753-6.68 6.753-6.548-2.913-6.507-6.507c.045-3.625 2.975-6.552 6.507-6.502",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9B6A8",
    d: "M41.688 1.646c3.592.05 6.68 2.667 6.68 6.26s-3.088 6.75-6.68 6.75c-3.594 0-6.549-2.914-6.507-6.507.045-3.626 2.975-6.553 6.507-6.503",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9B7A9",
    d: "M41.692 1.65c3.593.05 6.676 2.667 6.676 6.26s-3.083 6.75-6.676 6.75-6.548-2.914-6.507-6.507c.045-3.626 2.976-6.552 6.507-6.503",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAB8AA",
    d: "M41.692 1.654c3.593.05 6.676 2.671 6.676 6.264s-3.083 6.746-6.676 6.746-6.548-2.914-6.507-6.507c.045-3.626 2.976-6.552 6.507-6.503",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAB9AB",
    d: "M41.696 1.658c3.593.05 6.671 2.676 6.671 6.268 0 3.594-3.078 6.742-6.671 6.742s-6.548-2.914-6.507-6.507c.045-3.626 2.975-6.552 6.507-6.503",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EABAAC",
    d: "M41.7 1.662c3.593.05 6.672 2.675 6.672 6.268s-3.079 6.742-6.672 6.742-6.548-2.914-6.507-6.507c.041-3.626 2.976-6.552 6.507-6.503",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EABBAD",
    d: "M41.7 1.667c3.593.045 6.667 2.679 6.667 6.272s-3.074 6.737-6.667 6.737-6.548-2.914-6.507-6.507c.041-3.626 2.972-6.548 6.507-6.502",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBBBAE",
    d: "M41.704 1.67c3.593.046 6.667 2.684 6.667 6.277s-3.074 6.733-6.667 6.733-6.544-2.914-6.507-6.507c.041-3.621 2.972-6.548 6.507-6.502",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBBCAF",
    d: "M41.708 1.675c3.593.045 6.664 2.687 6.664 6.276s-3.07 6.733-6.664 6.733-6.544-2.914-6.506-6.507c.04-3.621 2.971-6.548 6.506-6.502",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBBDB0",
    d: "M41.708 1.679c3.593.045 6.664 2.687 6.664 6.28s-3.07 6.73-6.664 6.73-6.544-2.915-6.506-6.507c.04-3.622 2.971-6.549 6.506-6.503",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBBEB1",
    d: "M41.712 1.683c3.593.045 6.66 2.692 6.66 6.285s-3.067 6.725-6.66 6.725-6.544-2.914-6.507-6.507c.042-3.622 2.972-6.548 6.507-6.503",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECBFB2",
    d: "M41.716 1.687c3.593.045 6.66 2.696 6.66 6.285s-3.067 6.725-6.66 6.725-6.544-2.914-6.507-6.507c.041-3.622 2.968-6.548 6.507-6.503",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECC0B3",
    d: "M41.716 1.691c3.593.045 6.655 2.696 6.655 6.289s-3.062 6.72-6.655 6.72-6.544-2.913-6.507-6.506c.041-3.622 2.968-6.548 6.507-6.503",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECC0B4",
    d: "M41.72 1.695c3.594.041 6.656 2.7 6.656 6.293s-3.062 6.717-6.655 6.717-6.544-2.914-6.507-6.507c.037-3.622 2.967-6.544 6.507-6.503",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECC1B5",
    d: "M41.725 1.7c3.593.04 6.65 2.703 6.65 6.296s-3.057 6.713-6.65 6.713-6.544-2.914-6.507-6.507c.037-3.622 2.967-6.544 6.506-6.503",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC2B6",
    d: "M41.724 1.704c3.593.04 6.651 2.704 6.651 6.297s-3.058 6.712-6.65 6.712c-3.594 0-6.54-2.914-6.507-6.507.037-3.621 2.967-6.544 6.506-6.502",
    opacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC3B7",
    d: "M41.729 1.708c3.593.04 6.647 2.708 6.647 6.3 0 3.594-3.054 6.71-6.647 6.71s-6.54-2.915-6.507-6.508c.037-3.621 2.967-6.543 6.507-6.502",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC4B8",
    d: "M41.733 1.712c3.593.041 6.647 2.712 6.647 6.305s-3.054 6.705-6.647 6.705-6.54-2.914-6.507-6.507c.037-3.622 2.963-6.544 6.507-6.503",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDC5B9",
    d: "M41.733 1.716c3.593.04 6.642 2.712 6.642 6.305s-3.05 6.704-6.642 6.704-6.54-2.913-6.507-6.506c.037-3.618 2.963-6.544 6.507-6.503",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC5BA",
    d: "M41.737 1.72c3.593.041 6.643 2.716 6.643 6.31 0 3.592-3.05 6.7-6.643 6.7s-6.54-2.914-6.507-6.507c.037-3.618 2.964-6.544 6.507-6.503",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC6BB",
    d: "M41.741 1.724c3.593.041 6.639 2.72 6.639 6.314 0 3.592-3.046 6.696-6.639 6.696s-6.54-2.914-6.507-6.507c.037-3.618 2.963-6.544 6.507-6.503",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC7BC",
    d: "M41.745 1.728c3.593.037 6.639 2.72 6.639 6.314s-3.046 6.696-6.639 6.696-6.54-2.914-6.506-6.507c.033-3.618 2.963-6.54 6.506-6.503",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC8BD",
    d: "M41.745 1.732c3.593.037 6.635 2.725 6.635 6.318s-3.042 6.692-6.635 6.692-6.54-2.914-6.506-6.507c.033-3.618 2.963-6.54 6.506-6.503",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC9BE",
    d: "M41.75 1.736c3.592.037 6.634 2.73 6.634 6.322s-3.042 6.688-6.635 6.688-6.54-2.914-6.503-6.507c.033-3.617 2.96-6.54 6.503-6.503",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCABF",
    d: "M41.754 1.74c3.593.038 6.63 2.733 6.63 6.322s-3.038 6.688-6.63 6.688-6.536-2.914-6.503-6.507c.033-3.617 2.959-6.54 6.503-6.502",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCAC0",
    d: "M41.754 1.745c3.593.037 6.63 2.733 6.63 6.326s-3.038 6.683-6.63 6.683-6.536-2.913-6.503-6.506c.033-3.618 2.959-6.54 6.503-6.503",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBC1",
    d: "M41.757 1.749c3.593.037 6.627 2.737 6.627 6.33s-3.038 6.68-6.627 6.68-6.535-2.914-6.502-6.507c.033-3.618 2.959-6.54 6.502-6.503",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CCC2",
    d: "M41.762 1.753c3.593.037 6.626 2.741 6.626 6.334s-3.033 6.68-6.626 6.68-6.536-2.914-6.503-6.507c.033-3.618 2.96-6.54 6.503-6.503z",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CDC3",
    d: "M41.762 1.757c3.593.033 6.626 2.741 6.626 6.334s-3.033 6.676-6.626 6.676-6.536-2.914-6.503-6.507c.033-3.618 2.955-6.536 6.503-6.503",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CEC4",
    d: "M41.766 1.761c3.593.033 6.622 2.745 6.622 6.338s-3.03 6.672-6.622 6.672-6.536-2.914-6.503-6.507c.029-3.614 2.955-6.536 6.503-6.503",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CFC5",
    d: "M41.77 1.765c3.593.033 6.622 2.75 6.622 6.342 0 3.593-3.029 6.668-6.622 6.668s-6.536-2.914-6.503-6.507c.03-3.614 2.955-6.536 6.503-6.503",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1CFC6",
    d: "M41.77 1.77c3.593.032 6.618 2.749 6.618 6.342s-3.025 6.667-6.618 6.667-6.536-2.914-6.503-6.507c.03-3.613 2.955-6.536 6.503-6.503",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1D0C7",
    d: "M41.774 1.773c3.593.033 6.618 2.754 6.618 6.347s-3.025 6.663-6.618 6.663-6.532-2.914-6.503-6.507c.029-3.613 2.955-6.535 6.503-6.503",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1D1C8",
    d: "M41.778 1.782c3.593.033 6.614 2.757 6.614 6.35s-3.02 6.66-6.614 6.66-6.531-2.915-6.502-6.507c.028-3.614 2.955-6.536 6.502-6.503",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1D2C9",
    d: "M41.778 1.786c3.593.033 6.614 2.757 6.614 6.35s-3.02 6.66-6.614 6.66-6.531-2.914-6.502-6.507c.028-3.614 2.95-6.536 6.502-6.503",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2D3CA",
    d: "M41.782 1.79c3.593.029 6.61 2.761 6.61 6.354s-3.017 6.656-6.61 6.656-6.531-2.914-6.502-6.507c.028-3.614 2.95-6.536 6.502-6.503",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2D4CB",
    d: "M41.786 1.794c3.593.029 6.61 2.766 6.61 6.359s-3.017 6.65-6.61 6.65-6.531-2.913-6.503-6.506c.03-3.614 2.951-6.532 6.503-6.503",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2D4CC",
    d: "M41.79 1.798c3.593.029 6.606 2.77 6.606 6.359s-3.013 6.65-6.605 6.65-6.532-2.913-6.503-6.506c.025-3.614 2.95-6.532 6.503-6.503",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2D5CD",
    d: "M41.79 1.802c3.593.029 6.606 2.77 6.606 6.363s-3.013 6.647-6.605 6.647-6.532-2.914-6.503-6.507c.025-3.614 2.95-6.532 6.503-6.503",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D6CE",
    d: "M41.795 1.806c3.592.03 6.601 2.774 6.601 6.367s-3.009 6.643-6.602 6.643c-3.592 0-6.531-2.914-6.502-6.507.024-3.61 2.947-6.531 6.502-6.503",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D7CF",
    d: "M41.799 1.81c3.593.03 6.601 2.779 6.601 6.367 0 3.59-3.008 6.643-6.601 6.643s-6.528-2.914-6.503-6.507c.025-3.61 2.947-6.531 6.503-6.502",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D8D0",
    d: "M41.799 1.815c3.593.028 6.597 2.778 6.597 6.37 0 3.594-3.004 6.64-6.597 6.64s-6.528-2.915-6.503-6.508c.025-3.609 2.947-6.531 6.503-6.502",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3D9D1",
    d: "M41.803 1.819C45.396 1.844 48.4 4.6 48.4 8.194s-3.004 6.634-6.597 6.634-6.528-2.913-6.503-6.506c.025-3.61 2.947-6.532 6.503-6.503",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4D9D2",
    d: "M41.807 1.823C45.4 1.847 48.4 4.609 48.4 8.202s-3 6.634-6.593 6.634-6.527-2.913-6.503-6.506c.025-3.61 2.947-6.528 6.503-6.503z",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DAD3",
    d: "M41.807 1.827c3.593.025 6.593 2.786 6.593 6.38 0 3.592-3 6.63-6.593 6.63s-6.527-2.914-6.503-6.507c.025-3.61 2.947-6.528 6.503-6.503",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DBD4",
    d: "M41.811 1.831c3.593.025 6.59 2.79 6.59 6.384 0 3.593-2.997 6.626-6.59 6.626s-6.527-2.914-6.503-6.507c.02-3.61 2.943-6.527 6.503-6.503",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DCD5",
    d: "M41.815 1.835c3.593.025 6.59 2.795 6.59 6.388s-2.997 6.622-6.59 6.622-6.527-2.914-6.502-6.507c.02-3.61 2.942-6.528 6.502-6.503",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DDD6",
    d: "M41.815 1.84c3.593.024 6.586 2.794 6.586 6.387s-2.993 6.622-6.586 6.622-6.527-2.914-6.502-6.507c.02-3.61 2.942-6.527 6.502-6.503",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DED7",
    d: "M41.82 1.843c3.592.025 6.584 2.8 6.584 6.392s-2.992 6.618-6.585 6.618-6.523-2.914-6.503-6.507c.021-3.61 2.943-6.527 6.503-6.503",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DED8",
    d: "M41.823 1.848c3.593.02 6.581 2.802 6.581 6.395s-2.988 6.614-6.58 6.614c-3.594 0-6.524-2.914-6.504-6.507.021-3.61 2.943-6.527 6.503-6.502",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5DFD9",
    d: "M41.823 1.852c3.593.02 6.581 2.802 6.581 6.395 0 3.594-2.988 6.614-6.58 6.614-3.594 0-6.524-2.914-6.504-6.507.021-3.605 2.939-6.527 6.503-6.502",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6E0DA",
    d: "M41.828 1.856c3.592.02 6.576 2.807 6.576 6.4s-2.984 6.61-6.576 6.61c-3.593 0-6.524-2.914-6.503-6.507.02-3.606 2.938-6.524 6.503-6.503",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6E1DB",
    d: "M41.832 1.86c3.592.02 6.576 2.811 6.576 6.404s-2.984 6.606-6.577 6.606-6.523-2.914-6.502-6.507c.02-3.606 2.938-6.524 6.502-6.503",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6E2DC",
    d: "M41.836 1.864c3.593.02 6.573 2.815 6.573 6.404s-2.98 6.606-6.573 6.606-6.523-2.914-6.503-6.507c.017-3.605 2.939-6.523 6.503-6.503",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6E3DD",
    d: "M41.836 1.868c3.593.02 6.573 2.815 6.573 6.408s-2.98 6.602-6.573 6.602-6.523-2.914-6.503-6.507c.017-3.606 2.939-6.524 6.503-6.503",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E3DE",
    d: "M41.84 1.872c3.593.02 6.568 2.82 6.568 6.412s-2.975 6.598-6.568 6.598-6.524-2.914-6.503-6.507c.016-3.605 2.939-6.523 6.503-6.503",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E4DF",
    d: "M41.844 1.876c3.593.017 6.569 2.824 6.569 6.413 0 3.588-2.976 6.597-6.569 6.597s-6.52-2.914-6.503-6.507c.017-3.605 2.935-6.523 6.503-6.503",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E5E0",
    d: "M41.844 1.88c3.593.017 6.565 2.824 6.565 6.417s-2.976 6.593-6.565 6.593-6.52-2.914-6.503-6.507c.017-3.605 2.935-6.523 6.503-6.503",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E6E1",
    d: "M41.848 1.885c3.593.016 6.565 2.827 6.565 6.42s-2.972 6.59-6.565 6.59-6.52-2.915-6.503-6.508c.017-3.605 2.935-6.519 6.503-6.502",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E7E2",
    d: "M41.852 1.889c3.593.016 6.565 2.831 6.565 6.424s-2.972 6.59-6.565 6.59c-3.592 0-6.519-2.915-6.502-6.507.016-3.606 2.934-6.52 6.502-6.503z",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E8E3",
    d: "M41.852 1.893c3.593.016 6.56 2.831 6.56 6.424s-2.967 6.586-6.56 6.586-6.519-2.914-6.502-6.507c.016-3.602 2.934-6.52 6.502-6.503",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E8E4",
    d: "M41.856 1.897c3.593.016 6.56 2.836 6.56 6.429s-2.967 6.58-6.56 6.58-6.519-2.913-6.502-6.506c.012-3.601 2.93-6.52 6.502-6.503",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E9E5",
    d: "M41.86 1.901c3.593.016 6.557 2.84 6.557 6.433s-2.964 6.577-6.557 6.577-6.519-2.914-6.502-6.507c.012-3.601 2.93-6.52 6.502-6.503",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EAE6",
    d: "M41.86 1.905c3.593.012 6.557 2.84 6.557 6.433s-2.964 6.577-6.557 6.577S35.341 12 35.358 8.408c.012-3.601 2.93-6.52 6.502-6.503",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBE7",
    d: "M41.865 1.91c3.593.012 6.552 2.843 6.552 6.436s-2.96 6.573-6.552 6.573c-3.593 0-6.516-2.914-6.503-6.507.012-3.601 2.93-6.52 6.503-6.503",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9ECE8",
    d: "M41.869 1.913c3.593.013 6.552 2.848 6.552 6.441s-2.96 6.569-6.553 6.569-6.515-2.914-6.502-6.507c.012-3.601 2.93-6.52 6.502-6.503",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EDE9",
    d: "M41.869 1.922c3.593.012 6.547 2.848 6.547 6.44 0 3.594-2.954 6.57-6.547 6.57s-6.516-2.915-6.503-6.508c.012-3.6 2.93-6.515 6.502-6.502",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAEDEA",
    d: "M41.873 1.926c3.593.012 6.548 2.852 6.548 6.445s-2.955 6.564-6.548 6.564-6.515-2.913-6.503-6.506c.013-3.602 2.926-6.516 6.503-6.503",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAEEEB",
    d: "M41.877 1.93c3.593.012 6.544 2.856 6.544 6.45 0 3.592-2.951 6.56-6.544 6.56s-6.515-2.914-6.503-6.507c.012-3.601 2.926-6.515 6.503-6.503",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAEFEC",
    d: "M41.881 1.934c3.593.012 6.544 2.86 6.544 6.45 0 3.588-2.95 6.56-6.544 6.56s-6.515-2.914-6.502-6.507c.008-3.602 2.926-6.515 6.502-6.503",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF0ED",
    d: "M41.881 1.938c3.593.012 6.54 2.86 6.54 6.453s-2.947 6.557-6.54 6.557-6.515-2.914-6.502-6.507c.008-3.601 2.926-6.515 6.502-6.503",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBF1EE",
    d: "M41.885 1.942c3.593.008 6.54 2.865 6.54 6.458s-2.947 6.552-6.54 6.552-6.515-2.914-6.503-6.507c.009-3.597 2.927-6.515 6.503-6.503",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBF2EF",
    d: "M41.89 1.946c3.592.009 6.535 2.869 6.535 6.458s-2.943 6.552-6.535 6.552-6.511-2.914-6.503-6.507c.008-3.597 2.926-6.515 6.502-6.503",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBF2F0",
    d: "M41.89 1.95c3.592.009 6.535 2.87 6.535 6.462 0 3.593-2.943 6.548-6.535 6.548s-6.511-2.914-6.503-6.507c.008-3.597 2.922-6.51 6.502-6.503",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBF3F1",
    d: "M41.893 1.955c3.593.008 6.532 2.872 6.532 6.465s-2.939 6.544-6.532 6.544-6.51-2.914-6.502-6.507c.008-3.597 2.922-6.51 6.502-6.502",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF4F2",
    d: "M41.897 1.959c3.593.008 6.532 2.877 6.532 6.47s-2.939 6.544-6.532 6.544-6.51-2.914-6.502-6.507c.008-3.597 2.922-6.511 6.502-6.503z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF5F3",
    d: "M41.897 1.963c3.593.008 6.528 2.877 6.528 6.47s-2.935 6.54-6.528 6.54-6.51-2.914-6.502-6.507c.008-3.597 2.922-6.511 6.502-6.503",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF6F4",
    d: "M41.902 1.967c3.593.008 6.527 2.88 6.527 6.474 0 3.593-2.934 6.535-6.527 6.535s-6.511-2.913-6.503-6.506c.004-3.598 2.922-6.511 6.503-6.503",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCF7F5",
    d: "M41.906 1.971c3.593.004 6.523 2.885 6.523 6.478s-2.93 6.532-6.523 6.532-6.511-2.914-6.503-6.507c.004-3.597 2.918-6.511 6.503-6.503",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF7F6",
    d: "M41.906 1.975c3.593.004 6.523 2.885 6.523 6.478s-2.93 6.532-6.523 6.532-6.511-2.914-6.503-6.507c.004-3.597 2.918-6.511 6.503-6.503",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF8F7",
    d: "M41.91 1.98c3.593.003 6.52 2.888 6.52 6.481s-2.927 6.528-6.52 6.528a6.5 6.5 0 0 1-6.503-6.507c.004-3.597 2.918-6.511 6.503-6.503",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF9F8",
    d: "M41.914 1.983c3.593 0 6.52 2.894 6.52 6.487s-2.927 6.523-6.52 6.523a6.5 6.5 0 0 1-6.503-6.507 6.5 6.5 0 0 1 6.503-6.503",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFAF9",
    d: "M41.914 1.988c3.593 0 6.515 2.893 6.515 6.486s-2.922 6.523-6.515 6.523A6.5 6.5 0 0 1 35.41 8.49c0-3.593 2.918-6.507 6.503-6.502",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFBFA",
    d: "M41.918 1.992c3.593 0 6.515 2.897 6.515 6.49s-2.922 6.52-6.515 6.52a6.5 6.5 0 0 1-6.502-6.508c0-3.593 2.918-6.506 6.502-6.502",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFB",
    d: "M41.922 1.996c3.593 0 6.511 2.901 6.511 6.494a6.52 6.52 0 0 1-6.51 6.515 6.5 6.5 0 0 1-6.504-6.507 6.5 6.5 0 0 1 6.503-6.502",
    opacity: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCFC",
    d: "M41.926 2c3.593 0 6.511 2.905 6.511 6.494s-2.918 6.515-6.51 6.515a6.5 6.5 0 0 1-6.504-6.506A6.5 6.5 0 0 1 41.926 2",
    opacity: 0.01
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__a",
    x1: 43.852,
    x2: 39.35,
    y1: 11.717,
    y2: 4.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F89B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F68820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F58120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover_svg__b",
    x1: 43.14,
    x2: 36.559,
    y1: 11.623,
    y2: -1.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68820",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#EE7F22",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E37226",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DB6829",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5602C",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D15C2D",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D05B2E",
    stopOpacity: 0.74
  })))));
};
export { SvgDiscover as ReactComponent };
export default __webpack_public_path__ + "static/discover.9d12348e.svg";